import { Autocomplete, Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, Grid2, Input, InputLabel, MenuItem, Modal, Select, TextField, Typography } from "@mui/material"
import React, { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";

import { useFormik } from 'formik';

import "trix/dist/trix.css";
import "trix";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { Formik, Form, Field, ErrorMessage } from 'formik';

import { memberSchema } from '../../../schemas';
import { filterMembers, Report } from '../reports/member_reports/member';
import CustomModal from '../../../base-components/CustomModal';
import Popup from '../../../base-components/Popup';
import BarChartIcon from '@mui/icons-material/BarChart';

import StatsModal from './StatsModal.js';
import ResetMemberPasswordModal from './ResetMemberPasswordModal.js';

import RenderTable from './RenderTable.js';
import MemberExportModal from './MemberExportModal.js';
import { saveAs } from 'file-saver';
import { date } from 'yup';
import { encodedImagesURI } from '../../../utils/helpers.js';
import { nextSortState } from '../../../utils/memberTableSort.js';
import { getSessionUser, hasPermission, isDynamicStaffRole } from '../../../utils/roleAccess';
import { PageHeader, StatCard } from '../../../ui';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import RestoreIcon from '@mui/icons-material/Restore';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';

const isPersonalCoachingMember = (m) => m.is_trainer && m.trainer_id;

const MEMBER_TAB_ORDER = [
  "all",
  "active",
  "inactive",
  "new",
  "restored",
  "personal_coaching",
];

const BASE_URL = process.env.REACT_APP_BASE_URL;

function normalizeLocationId(locationId) {
  if (typeof locationId === "object" && locationId?._id) return locationId._id;
  return locationId || "";
}

function isMemberLocationScoped(role, locationId, sessionUser) {
  const resolved = normalizeLocationId(locationId);
  return role === "ClubAdmin" || (isDynamicStaffRole(role, sessionUser) && Boolean(resolved));
}

function MembersRosterSkeleton() {
  return (
    <div className="space-y-4" aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading members</span>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={`stat-${i}`}
            className="bg-gx-surface border border-gx-border rounded-gx px-4 py-4 min-h-[108px]"
          >
            <div className="h-3 w-20 rounded-gx bg-gx-border/70 animate-pulse" />
            <div className="h-8 w-12 rounded-gx bg-gx-border/70 animate-pulse mt-4" />
            <div className="h-3 w-24 rounded-gx bg-gx-border/70 animate-pulse mt-2" />
          </div>
        ))}
      </div>
      <div className="flex gap-2 border-b border-gx-border pb-2">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={`tab-${i}`} className="h-9 w-24 rounded-gx bg-gx-border/70 animate-pulse shrink-0" />
        ))}
      </div>
      <div className="bg-gx-surface rounded-gx border border-gx-border shadow-gx overflow-hidden p-5">
        <div className="h-4 w-32 rounded-gx bg-gx-border/70 animate-pulse" />
        <div className="h-11 w-full rounded-gx bg-gx-border/70 animate-pulse mt-4" />
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={`card-${i}`}
              className="rounded-gx border border-gx-border bg-gx-canvas/40 min-h-[160px] p-4"
            >
              <div className="flex gap-3">
                <div className="w-14 h-14 rounded-gx bg-gx-border/70 animate-pulse shrink-0" />
                <div className="flex-1 space-y-2">
                  <div className="h-4 w-36 rounded-gx bg-gx-border/70 animate-pulse" />
                  <div className="h-3 w-24 rounded-gx bg-gx-border/70 animate-pulse" />
                  <div className="h-3 w-full rounded-gx bg-gx-border/70 animate-pulse" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

  function Members() {

  const navigate = useNavigate()
  const selectPhotoRef = useRef(null)
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const editorRef = useRef(null);

    const [cameraStream, setCameraStream] = useState(null);
    const [members , setMembers] = useState([])
    const [active_members , setActiveMembers] = useState(0)
    const [inactive_members , setInactiveMembers] = useState(0)
    const [restored_members , setRestoredMembers] = useState(0)
    const [due_fee,setDueFee]=useState([])
    const [new_members , setNewMembers] = useState(0)
    const [member , setMember] = useState({})
    const initialSessionUser = getSessionUser();
    const [role , setRole] = useState(initialSessionUser?.role || '')
    const [locations , setLocations] = useState([])
    const [trainers , setTrainers] = useState([])
    const [showPassword , setShowPassword] = useState(false)
    const [memberToDelete , setMemberToDelete] = useState('')
    const [memberToRestore , setMemberToRestore] = useState('')
    const [currentDate , setCurrentDate] = useState(new Date())
     const [voucher , setVoucher] = useState()
    const [memberToAdvance , setMemberToAdvance] = useState('')
    const [memberToUpdate , setMemberToUpdate] = useState('')
    const [isAddModalOpen , setIsAddModalOpen] = useState(false)
    const [isViewModalOpen , setIsViewModalOpen] = useState(false)
    const [isEmailModalOpen , setIsEmailModalOpen] = useState(false)
    const [isSmsModalOpen, setIsSmsModalOpen] = useState(false)
    const [isDeleteModalOpen , setIsDeleteModalOpen] = useState(false)
    const [isRestoreModalOpen , setIsRestoreModalOpen] = useState(false)
    const [isUpdateModalOpen , setIsUpdateModalOpen] = useState(false)
    const [isAdvanceModalOpen , setIsAdvanceModalOpen] = useState(false)
    const[isChargesModalOpen,setIsChargesModalOpen]=useState(false)
    const[isPackageModalOpen,setIsPackageModalOpen]=useState(false)
    const[isTrainerModalOpen,setIsTrainerModalOpen]=useState(false)
    const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = useState(false)
    const [memberForPasswordReset, setMemberForPasswordReset] = useState(null)
    const [actingUserId, setActingUserId] = useState('')
    const[isTrainer, setIsTrainer]=useState(false)
    const [selectedPackage , setSelectedPackage] = useState('')
    const [selectedTrainer , setSelectedTrainer] =useState('')
    const [selectedSubStartDate , setSelectedSubStartDate] =useState('')
    const [countries , setCountries] = useState([])
    const [states , setStates] = useState([])
    const [cities , setCities] = useState([])
    const [isSuccessAlert , setIsSuccessAlert] = useState(false)
    const [isFaliureAlert , setIsFailureAlert] = useState(false)
    const [successMessage , setSuccessMessage] = useState('')
    const [failureMessage , setFailureMessage] = useState('')
    const [isPopupOpen , setIsPopupOpen] = useState(false)
    const [tabType , setTabType] = useState('all')
    const [tabData , setTabData] = useState([
      { key: 'inactive', label: 'Inactive', members: [], count: 0 },
      { key: 'active', label: 'Active', members: [], count: 0 },
      { key: 'all', label: 'All', members: [], count: 0 },
      { key: 'new', label: 'New', members: [], count: 0 },
      { key: 'restored', label: 'Returning', members: [], count: 0 },
      { key: 'personal_coaching', label: 'Personal Coaching', members: [], count: 0 },
    ])
    const [packages , setPackages] = useState([])
    const [member_package_amount , setMemberPackageAmount] = useState(0)
    const [member_registration_amount , setMemberRegistrationAmount] = useState('')
    const [company_id , setCompanyID] = useState(initialSessionUser?.company_id || '')
    const [location_id , setLocationID] = useState(initialSessionUser?.location_id || '')
    const [photo , setPhoto] = useState('')
    const [loading , setLoading] = useState(false)
    const [rosterLoading, setRosterLoading] = useState(true)
    const [listFetching, setListFetching] = useState(false);
    const [exportPreparing, setExportPreparing] = useState(false);
    const [exportMessage, setExportMessage] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredMembers, setFilteredMembers] = useState([]);
    const {id} = useParams()
    const [open, setOpen] = useState(false);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, total: 0, totalPages: 0 });
    const [counts, setCounts] = useState({
      all: 0,
      active: 0,
      inactive: 0,
      new: 0,
      restored: 0,
      personal_coaching: 0,
      with_trainer_active: 0,
    });
    const [sortBy, setSortBy] = useState(null);
    const [sortDir, setSortDir] = useState(null);
    const [filterParams, setFilterParams] = useState({
      package_id: "",
      gender: "",
      from_date: "",
      to_date: "",
      is_active: "",
      fee_status: "",
    });
    const useServerPagination = role === "Admin" || role === "ClubAdmin";
    const searchDebounceRef = useRef(null);
    const isFirstSearchMountRef = useRef(true);
    
    const [emailData , setEmailData] = useState({})
    const CUSTOM_SMS_MAX_LENGTH = 320;
    const SMS_DROPDOWN_PAGE_SIZE = 20;
    const [smsMessage, setSmsMessage] = useState("");
    const [smsSelectedMembers, setSmsSelectedMembers] = useState([]);
    const [smsMemberOptions, setSmsMemberOptions] = useState([]);
    const [smsInputValue, setSmsInputValue] = useState("");
    const [smsOptionsPage, setSmsOptionsPage] = useState(1);
    const [smsOptionsHasMore, setSmsOptionsHasMore] = useState(false);
    const [smsLoadingOptions, setSmsLoadingOptions] = useState(false);
    const [smsSending, setSmsSending] = useState(false);
    const [smsEnabled, setSmsEnabled] = useState(false);
    const SMS_FILTER_DEFAULTS = {
      all: false,
      active: false,
      inactive: false,
      new: false,
      restored: false,
      personal_coaching: false,
    };
    const [smsMemberFilters, setSmsMemberFilters] = useState({ ...SMS_FILTER_DEFAULTS });
    const smsSearchDebounceRef = useRef(null);
    const smsSearchAbortRef = useRef(null);
    const smsSearchQueryRef = useRef("");
    const [paymentData , setPaymentData] = useState({
            payment_method: 'Cash',
            payment_type: 'Payment',
            amount: 0
    })
    const [damagesData , setDamagesData] = useState({
      remarks: '',
      amount: 0,
      charges_name: '',
})
    const [buttonLoading, setButtonLoading] = useState(false);

    const sessionUserForScope = getSessionUser();
    const scopedLocationId = normalizeLocationId(
      location_id || sessionUserForScope?.location_id
    );
    const isLocationScoped = isMemberLocationScoped(
      role,
      location_id || sessionUserForScope?.location_id,
      sessionUserForScope
    );

    useEffect(()=> {
        const sessionStr = sessionStorage.getItem('user-info');
        if(sessionStr){
          const session = JSON.parse(sessionStr);
          setRole(session.user.role)
          setCompanyID(session.user.company_id)
          setLocationID(session.user.location_id)
          setActingUserId(session.user._id || '')
        }
         else {
          navigate('/login');
        }
  },[])
  useEffect(() => {
    if (!role) return;
    const sessionUser = getSessionUser();
    const resolvedCompanyId = company_id || sessionUser?.company_id;
    const resolvedLocationId = location_id || sessionUser?.location_id;
    if (role === "Admin" && !resolvedCompanyId) return;
    if (role !== "Admin" && role !== "SuperAdmin" && !resolvedLocationId) return;

    setRosterLoading(true);
    const fetchData = async () => {
      try {
        await Promise.all([
          getMembers(),
          getCountries(),
          !isLocationScoped ? getLocations() : Promise.resolve(),
          getPackages(),
          getTrainers(),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setRosterLoading(false);
      }
    };
    fetchData();
  }, [role, company_id, location_id, isLocationScoped]);

  useEffect(() => {
    const checkSmsAvailability = async () => {
      if (!role || !company_id) {
        setSmsEnabled(false);
        return;
      }
      try {
        const params = new URLSearchParams({ company_id: String(company_id) });
        // ClubAdmin: require location-scoped (or company fallback) config
        if (role === "ClubAdmin" && location_id) {
          params.set("location_id", String(location_id));
        } else if (isDynamicStaffRole(role) && location_id) {
          params.set("location_id", String(location_id));
        }
        const response = await fetch(`${BASE_URL}members/sms-availability?${params}`);
        const data = await response.json().catch(() => ({}));
        setSmsEnabled(Boolean(data.enabled));
      } catch (error) {
        console.error("Failed to check SMS availability:", error);
        setSmsEnabled(false);
      }
    };
    checkSmsAvailability();
  }, [role, company_id, location_id]);

  useEffect(() => {
    if (!useServerPagination || role === "SuperAdmin") return;
    if (isFirstSearchMountRef.current) {
      isFirstSearchMountRef.current = false;
      return;
    }
    if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => {
      getMembers(1, tabType, pagination.limit, searchQuery, filterParams, { sortBy, sortDir }, { manageListFetching: true });
      searchDebounceRef.current = null;
    }, 400);
    return () => {
      if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    };
  }, [searchQuery]);
  
useEffect(() => {
    if (videoRef.current && cameraStream) {
      // This ensures that the video element is available before assigning the stream
      videoRef.current.srcObject = cameraStream;
  
      // Wait for the video to load and then play
      videoRef.current.onloadedmetadata = () => {
        videoRef.current.play();
      };
    }
  }, [cameraStream]); // Re-run when cameraStream changes

  useEffect(() => {
    // Get reference to the trix-editor element
    const editor = editorRef.current;

    // Add the `trix-change` event listener to the <trix-editor> element
    const handleTrixChange = (event) => {
      const htmlContent = editor.innerHTML; // Retrieve the HTML content of the editor
      setEmailData((prevData) => ({
        ...prevData,
        html: htmlContent,
      }));
    };
    editor.addEventListener("trix-change", handleTrixChange);
    // Cleanup event listener when component unmounts
    return () => {
      editor.removeEventListener("trix-change", handleTrixChange);
    };
  }, []);



  // async function getAllVouchers() {
  //   let endpoint = 'voucher/getAllVouchers'; 
  
  //   try {
  //     const response = await fetch(BASE_URL + endpoint);
      
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     }
  
  //     const data = await response.json();
  //     setVoucher(data.voucher);
  //     // setFilteredLedgers(data.voucher);
  //   } catch (error) {
  //     console.error("Error fetching vouchers:", error);
  //   }
  // }
  




  async function getPackages() {
    let endpoint = '';
    if (role === 'SuperAdmin') {
        endpoint = `package/getPackages`;
    } else if (role === 'Admin') {
        endpoint = `package/getPackagesByCompanyID/${company_id}`;
    } else if(role === 'ClubAdmin') {
        endpoint = `package/getPackagesByLocationID/${location_id}`;
    } else if (isDynamicStaffRole(role)) {
        endpoint = `package/getPackagesByLocationID/${location_id}`;
    }
    return fetch(BASE_URL + endpoint)
        .then((response) => response.json())
        .then((data) => {
            setPackages(data.packages)
        })
        .catch((error) => console.log(error));
  }
  async function getTrainers() {
    let endpoint = '';
    if (role === 'SuperAdmin') {
        endpoint = `trainers/get-trainers`;
    } else if (role === 'Admin') {
        endpoint = `trainers/get-trainers-by-company/${company_id}`;
    } else if(role === 'ClubAdmin') {
        endpoint = `trainers/get-trainers-by-location/${location_id}`;
    } else if (isDynamicStaffRole(role)) {
        endpoint = `trainers/get-trainers-by-location/${location_id}`;
    }
    return fetch(BASE_URL + endpoint)
        .then((response) => response.json())
        .then((data) => {
            setTrainers(data.trainers)
        })
        .catch((error) => console.log(error));
  }

  async function getLocations() {
    if (!role) return;
    let endpoint = '';
    const sessionUser = getSessionUser();
    if (role === 'SuperAdmin') {
        endpoint = 'locations/getLocations';
    } else if (
      role === 'Admin' ||
      role === 'ClubAdmin' ||
      isDynamicStaffRole(role, sessionUser)
    ) {
        if (!company_id) return;
        endpoint = `locations/getLocationsByCompanyID/${company_id}`;
    }
    if (!endpoint) return;
    return fetch(BASE_URL + endpoint)
        .then((response) => response.json())
        .then((data) => {
            if(data?.locations) {
              setLocations(data.locations)
            }
        })
        .catch((error) => console.log(error));
  }

  async function getCountries () {
      return fetch(BASE_URL + `country/getCountries`)
      .then((response) => response.json())
      .then((data) => {
          if(data){
            setCountries(data)
          }

      })
      .catch((error) => console.log(error));
  
  }

  const getStates = async (value) => {
      await fetch(BASE_URL + `country/getStatesById/${value}`)
      .then((response) => response.json())
      .then((data) => {
          if(data){
            setStates(data)
          }

      })
      .catch((error) => console.log(error));
  }

  const getCities = async (value) => {
      await fetch(BASE_URL + `country/getCitiesById/${value}`)
      .then((response) => response.json())
      .then((data) => {
          if(data){
            setCities(data)
          }
      })
      .catch((error) => console.log(error));
  }

  async function getMemberPackage (id) {
    await fetch(BASE_URL + `package/getPackageById/${id}`)
    .then((response) => response.json())
    .then((data) => {
        setMemberPackageAmount(data.packages.membership_fee)
        // setMemberRegistrationAmount(data.packages.registration_fee)
        
    })
    .catch((error) => console.log(error));
}
  
const bufferToBase64 = (buffer) => {
    const uint8Array = new Uint8Array(buffer);
    let binary = '';
    uint8Array.forEach(byte => {
      binary += String.fromCharCode(byte);
    });
    return `data:image/jpeg;base64,${window.btoa(binary)}`;
  };

  function appendMemberListQueryParams(params, { page, limit, tabKey, search, filters, sort }) {
    const currentTab = tabKey ?? tabType;
    const currentFilters = filters ?? filterParams;
    const currentSearch = search !== undefined && search !== null ? search : searchQuery;
    const currentSort = sort ?? { sortBy, sortDir };

    if (page != null) params.set("page", String(page));
    if (limit != null) params.set("limit", String(limit));

    const statusFilter = currentFilters.is_active;
    if (statusFilter === "true" || statusFilter === "false") {
      params.set("is_active", statusFilter);
    } else if (currentTab === "active") {
      params.set("is_active", "true");
    } else if (currentTab === "inactive") {
      params.set("is_active", "false");
    }
    if (currentTab === "new") params.set("is_new", "true");
    if (currentTab === "restored") params.set("is_restored", "true");
    else if (currentTab === "personal_coaching") params.set("is_trainer", "true");

    if (currentSearch && currentSearch.trim()) params.set("search", currentSearch.trim());
    if (currentSort?.sortBy && currentSort?.sortDir) {
      params.set("sort_by", currentSort.sortBy);
      params.set("sort_dir", currentSort.sortDir);
    }
    if (currentFilters.package_id) params.set("package_id", currentFilters.package_id);
    if (currentFilters.gender) params.set("gender", currentFilters.gender);
    if (currentFilters.from_date) params.set("from_date", currentFilters.from_date);
    if (currentFilters.to_date) params.set("to_date", currentFilters.to_date);
    if (currentFilters.fee_status) params.set("fee_status", currentFilters.fee_status);
  }

  function memberExportHasFiltersApplied(filters = filterParams) {
    return !!(
      filters.package_id ||
      filters.gender ||
      filters.from_date ||
      filters.to_date ||
      filters.fee_status
    );
  }

  async function downloadMembersExcel(scope) {
    const totalHint = pagination.total ? ` (${pagination.total.toLocaleString()} members)` : "";
    setExportMessage(
      scope === "all"
        ? `Building a full roster export${totalHint}. This may take a minute for large clubs.`
        : scope === "filtered"
          ? `Building export for your filtered roster${totalHint}.`
          : "Building export for the current page."
    );
    setExportPreparing(true);
    try {
      const params = new URLSearchParams();
      params.set("scope", scope);
      if (scope !== "all") {
        appendMemberListQueryParams(params, {
          page: scope === "page" ? pagination.page : undefined,
          limit: scope === "page" ? pagination.limit : undefined,
          tabKey: tabType,
          search: searchQuery,
          filters: filterParams,
          sort: { sortBy, sortDir },
        });
      }
      const response = await fetch(`${BASE_URL}members/export?${params.toString()}`, {
        method: "GET",
        headers: {
          "x-acting-user-id": getSessionUser()?._id || "",
        },
      });
      if (!response.ok) {
        let message = "Failed to export members. Please try again.";
        try {
          const body = await response.json();
          if (body?.message) message = body.message;
        } catch (_) {}
        throw new Error(message);
      }
      const blob = await response.blob();
      const disposition = response.headers.get("Content-Disposition") || "";
      const match = disposition.match(/filename="?([^"]+)"?/i);
      const filename = match?.[1] || `Members_${new Date().toISOString().slice(0, 10)}.xlsx`;
      saveAs(blob, filename);
    } catch (error) {
      console.error("Error exporting members:", error);
      alert(error?.message || "An error occurred while exporting. Please try again.");
    } finally {
      setExportPreparing(false);
      setExportMessage("");
    }
  }

  async function getMembers(page = 1, tabKey = null, limit = null, search = null, filters = null, sort = null, options = {}) {
    const { manageRosterLoading = false, manageListFetching = false } = options;
    const finishRosterLoading = () => {
      if (manageRosterLoading) setRosterLoading(false);
    };
    const startRosterLoading = () => {
      if (manageRosterLoading) setRosterLoading(true);
    };
    const finishListFetching = () => {
      if (manageListFetching) setListFetching(false);
    };
    const startListFetching = () => {
      if (manageListFetching) setListFetching(true);
    };
    const currentTab = tabKey ?? tabType;
    const currentLimit = limit ?? pagination.limit;
    const currentSearch = search !== undefined && search !== null ? search : searchQuery;
    const currentFilters = filters !== undefined && filters !== null ? filters : filterParams;
    const currentSort = sort ?? { sortBy, sortDir };
    if (role === "SuperAdmin") {
      startRosterLoading();
      return fetch(BASE_URL + "members/get-all-members")
        .then((response) => response.json())
        .then((data) => {
          const membersWithBase64 = (data.members || []).map((member) => {
            if (member.photo?.type === "Buffer") {
              member.photo = bufferToBase64(member.photo.data);
            }
            return member;
          });
          const coachingMembers = membersWithBase64.filter(isPersonalCoachingMember);
          const superCounts = {
            all: membersWithBase64.length,
            active: membersWithBase64.filter((m) => m.is_active).length,
            inactive: membersWithBase64.filter((m) => !m.is_active).length,
            new: membersWithBase64.filter((m) => m.is_new).length,
            restored: membersWithBase64.filter((m) => m.is_restored).length,
            personal_coaching: coachingMembers.length,
            with_trainer_active: coachingMembers.filter((m) => m.is_active).length,
          };
          setMembers(membersWithBase64);
          setCounts(superCounts);
          setActiveMembers(superCounts.active);
          setInactiveMembers(superCounts.inactive);
          setRestoredMembers(superCounts.restored);
          setNewMembers(superCounts.new);
          setTabData([
            { key: "inactive", label: "Inactive", members: membersWithBase64.filter((m) => !m.is_active), count: superCounts.inactive },
            { key: "active", label: "Active", members: membersWithBase64.filter((m) => m.is_active), count: superCounts.active },
            { key: "all", label: "All", members: membersWithBase64, count: superCounts.all },
            { key: "new", label: "New", members: membersWithBase64.filter((m) => m.is_new), count: superCounts.new },
            { key: "restored", label: "Returning", members: membersWithBase64.filter((m) => m.is_restored), count: superCounts.restored },
            { key: "personal_coaching", label: "Personal Coaching", members: coachingMembers, count: superCounts.personal_coaching },
          ]);
        })
        .catch(() => {
          setMembers([]);
          setCounts({ all: 0, active: 0, inactive: 0, new: 0, restored: 0, personal_coaching: 0, with_trainer_active: 0 });
          setTabData([
            { key: "inactive", label: "Inactive", members: [], count: 0 },
            { key: "active", label: "Active", members: [], count: 0 },
            { key: "all", label: "All", members: [], count: 0 },
            { key: "new", label: "New", members: [], count: 0 },
            { key: "restored", label: "Returning", members: [], count: 0 },
            { key: "personal_coaching", label: "Personal Coaching", members: [], count: 0 },
          ]);
        })
        .finally(() => {
          finishRosterLoading();
          finishListFetching();
        });
    }

    const sessionUser = getSessionUser();
    const resolvedCompanyId = company_id || sessionUser?.company_id;
    const resolvedLocationId = location_id || sessionUser?.location_id;
    if (role === "Admin" && !resolvedCompanyId) {
      finishRosterLoading();
      finishListFetching();
      return Promise.resolve();
    }
    if (role !== "Admin" && role !== "SuperAdmin" && !resolvedLocationId) {
      finishRosterLoading();
      finishListFetching();
      return Promise.resolve();
    }
    const endpoint =
      role === "Admin"
        ? `members/getMembersByCompanyID/${resolvedCompanyId}`
        : `members/getMembersByLocationID/${resolvedLocationId}`;
    const params = new URLSearchParams();
    appendMemberListQueryParams(params, {
      page,
      limit: currentLimit,
      tabKey: currentTab,
      search: currentSearch,
      filters: currentFilters,
      sort: currentSort,
    });

    startRosterLoading();
    startListFetching();
    return fetch(BASE_URL + endpoint + "?" + params.toString())
      .then((response) => response.json())
      .then((data) => {
        const membersWithBase64 = (data.members || []).map((member) => {
          if (member.photo?.type === "Buffer") {
            member.photo = bufferToBase64(member.photo.data);
          }
          return member;
        });
        setMembers(membersWithBase64);
        if (data.counts) {
          setCounts(data.counts);
          setActiveMembers(data.counts.active ?? 0);
          setInactiveMembers(data.counts.inactive ?? 0);
          setNewMembers(data.counts.new ?? 0);
          setRestoredMembers(data.counts.restored ?? 0);
        }
        if (data.pagination) {
          setPagination((prev) => ({
            ...prev,
            page: data.pagination.page,
            limit: data.pagination.limit,
            total: data.pagination.total,
            totalPages: data.pagination.totalPages,
          }));
        }
        setTabData([
          { key: "inactive", label: "Inactive", count: data.counts?.inactive ?? 0, members: membersWithBase64 },
          { key: "active", label: "Active", count: data.counts?.active ?? 0, members: membersWithBase64 },
          { key: "all", label: "All", count: data.counts?.all ?? 0, members: membersWithBase64 },
          { key: "new", label: "New", count: data.counts?.new ?? 0, members: membersWithBase64 },
          { key: "restored", label: "Returning", count: data.counts?.restored ?? 0, members: membersWithBase64 },
          { key: "personal_coaching", label: "Personal Coaching", count: data.counts?.personal_coaching ?? 0, members: membersWithBase64 },
        ]);
      })
      .catch(() => {
        setMembers([]);
        setCounts({ all: 0, active: 0, inactive: 0, new: 0, restored: 0, personal_coaching: 0, with_trainer_active: 0 });
        setTabData([
          { key: "inactive", label: "Inactive Members", count: 0, members: [] },
          { key: "active", label: "Active Members", count: 0, members: [] },
          { key: "all", label: "All Members", count: 0, members: [] },
          { key: "new", label: "New Members", count: 0, members: [] },
          { key: "restored", label: "Returning Members", count: 0, members: [] },
          { key: "personal_coaching", label: "Personal Coaching Members", count: 0, members: [] },
        ]);
      })
      .finally(() => {
        finishRosterLoading();
        finishListFetching();
      });
  }

  const handleSortChange = (columnKey, explicitDir) => {
    const next =
      columnKey == null || columnKey === "" || explicitDir === null
        ? { sortBy: null, sortDir: null }
        : explicitDir
          ? { sortBy: columnKey, sortDir: explicitDir }
          : nextSortState(sortBy, sortDir, columnKey);
    setSortBy(next.sortBy);
    setSortDir(next.sortDir);
    if (useServerPagination) {
      setPagination((prev) => ({ ...prev, page: 1 }));
      getMembers(1, tabType, pagination.limit, searchQuery, filterParams, next, { manageListFetching: true });
    }
  };


  async function getMemberByID (id) {
      await fetch(BASE_URL + `members/get-member/${id}`)
      .then((response) => response.json())
      .then((data) => {
        const photo64 = bufferToBase64(data.member.photo?.data)
          data.member.photo = base64ToBlob(photo64);
          setMember(data.member)
          setValues(data.member);
          setPhoto(photo64)
      })
     
      .catch((error) => console.log(error));
  }

  const handleAdvancePayment = async () => {
        if(paymentData.payment_method !== 'Cash' && !paymentData.reference_number){
          setIsFailureAlert(true);
          setFailureMessage('Please enter reference number');
          setIsPopupOpen(true);
          setTimeout(() => {
            setIsPopupOpen(false);
          }, 5000);
          return;
        }
        
        setButtonLoading(true);
        const data = {
            member_id: memberToAdvance._id,
            amount: paymentData.amount,
            transaction_type: paymentData.payment_type,
            payment_method: paymentData.payment_method,
            reference_number:paymentData.reference_number,
        }

        console.log('Advance payment function' , data);

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          };
        
          try {
            const response = await fetch(BASE_URL + `voucher/advance-payment`, requestOptions);
        
            if (!response.ok) {
              const data = await response.json();
              console.error('Response not ok:', data);
              setIsFailureAlert(true);
              setFailureMessage(data.message);
              setIsPopupOpen(true);
              setIsAdvanceModalOpen(false);
              setPaymentData({
                payment_method: 'Cash',
                payment_type: 'Payment',
                amount: 0
              })
              setTimeout(() => {
                setIsPopupOpen(false);
              }, 5000);
            } else {
              setIsAdvanceModalOpen(false);
              setIsSuccessAlert(true);
              setSuccessMessage('Advance Payment added Successfully');
              setIsPopupOpen(true);
              setPaymentData({
                payment_method: 'Cash',
                payment_type: 'Payment',
                amount: 0
              })
              setTimeout(() => {
                setIsPopupOpen(false);
              }, 5000);
            }
          } catch (error) {
            console.error('Caught error:', error);
            setIsFailureAlert(true);
            setFailureMessage('Failed to add Advance Payment');
            setIsPopupOpen(true);
            setTimeout(() => {
              setIsPopupOpen(false);
            }, 5000);
          } finally {
            setButtonLoading(false);
            setLoading(false);
          }
    }


    const handleChangePackage = async () => {
      const data = {
        member_id: member._id,
        package_id: selectedPackage,
    };
      const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        };
      setButtonLoading(true);
        try {
          const response = await fetch(BASE_URL + `members/change-member-package`, requestOptions);
      
          if (!response.ok) {
            const data = await response.json();
            console.error('Response not ok:', data);
            setIsFailureAlert(true);
            setFailureMessage(data.message);
            setIsPopupOpen(true);
            setIsPackageModalOpen(false);
            setTimeout(() => {
              setIsPopupOpen(false);
            }, 5000);
          } else {
            const responseData = await response.json().catch(() => ({}));
            await getMembers()
            if (isRestoreModalOpen && String(memberToRestore?._id) === String(member._id)) {
              const updatedPackageId =
                responseData?.member?.package_id ?? selectedPackage;
              setMemberToRestore((prev) =>
                prev
                  ? {
                      ...prev,
                      package_id: updatedPackageId,
                    }
                  : prev
              );
            }
            togglePackageModal();
            setIsSuccessAlert(true);
            setSuccessMessage('Package Updated Successfully');
            setIsPopupOpen(true);
            setTimeout(() => {
              setIsPopupOpen(false);
            }, 5000);
          }
        } catch (error) {
          console.error('Caught error:', error);
          setIsFailureAlert(true);
          setFailureMessage('Failed to Change Package');
          setIsPopupOpen(true);
          setTimeout(() => {
            setIsPopupOpen(false);
          }, 5000);
        } finally {
          setButtonLoading(false);
          setLoading(false);
        }
  }

  const handleChangeTrainer = async () => {
    const data = {
      member_id: member._id,
      trainer_id: selectedTrainer,
      is_trainer: isTrainer,
  };
      setButtonLoading(true);
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      };
    
      try {
        const response = await fetch(BASE_URL + `members/change-member-trainer`, requestOptions);
    
        if (!response.ok) {
          const data = await response.json();
          console.error('Response not ok:', data);
          setIsFailureAlert(true);
          setFailureMessage(data.message);
          setIsPopupOpen(true);
          setIsTrainerModalOpen(false);
          setTimeout(() => {
            setIsPopupOpen(false);
          }, 5000);
        } else {
          toggleTrainerModal();
          await getMembers()
          setIsSuccessAlert(true);
          setSuccessMessage('Trainer Updated Successfully');
          setIsPopupOpen(true);
          setTimeout(() => {
            setIsPopupOpen(false);
          }, 5000);
        }
      } catch (error) {
        console.error('Caught error:', error);
        setIsFailureAlert(true);
        setFailureMessage('Failed to Change Package');
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      } finally {
        setButtonLoading(false);
        setLoading(false);
      }
}



    const handleDamageInvoice = async () => {
      const data = {
        member_id : memberToAdvance._id,
        amount: damagesData.amount,
        charges_name: damagesData.charges_name,
        remarks: damagesData.remarks
      }
      console.log('Damage payment function' , data);
      setButtonLoading(true);

      const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        };
      
        try {
          const response = await fetch(BASE_URL + `voucher/extra-charges`, requestOptions);
      
          if (!response.ok) {
            const data = await response.json();
            console.error('Response not ok:', data);
            setIsFailureAlert(true);
            setFailureMessage(data.message);
            setIsPopupOpen(true);
            setIsChargesModalOpen(false);
            setDamagesData({
              remarks: '',
              amount: 0,
              charges_name: '',
            })
            setTimeout(() => {
              setIsPopupOpen(false);
            }, 5000);
          } else {
            setIsChargesModalOpen(false);
            setIsSuccessAlert(true);
            setSuccessMessage('Damage Invoice created Successfully');
            setIsPopupOpen(true);
            setDamagesData({
              remarks: '',
              amount: 0,
              charges_name: '',
            })
            setTimeout(() => {
              setIsPopupOpen(false);
            }, 5000);
          }
        } catch (error) {
          console.error('Caught error:', error);
          setIsFailureAlert(true);
          setFailureMessage('Failed to add Advance Payment');
          setIsPopupOpen(true);
          setTimeout(() => {
            setIsPopupOpen(false);
          }, 5000);
        } finally {
          setButtonLoading(false);
          setLoading(false);
        }
  }
  
  const handleAddMember = async (values, actions) => {
    values.company_id = company_id;
    if (isLocationScoped) {
      values.location_id = scopedLocationId;
    }
    if (!values.location_id) {
      setIsFailureAlert(true);
      setFailureMessage('Location is required for members.');
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
      }, 5000);
      return;
    }
    console.log('values' , values);
  
    const formData = new FormData();
    Object.keys(values).forEach((key) => {
      if (key === 'photo' && values[key]) {
        formData.append(key, values[key], 'photo.jpg'); 
      } else {
        formData.append(key, values[key]); 
      }
    });
  
    setLoading(true);
  
    const requestOptions = {
      method: "POST",
      body: formData, // Do not stringify FormData
    };
  
    try {
      const response = await fetch(BASE_URL + `members/create-member`, requestOptions);
  
      if (!response.ok) {
        const data = await response.json();
        console.error('Response not ok:', data);
        setIsFailureAlert(true);
        setFailureMessage(data.message);
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      } else {
        const data = await response.json();
        const voucher_id = data.Subscription.voucher.voucher._id;
        console.log("voucher_id: ", voucher_id);
        navigate(`/voucher/${voucher_id}`)
        setIsAddModalOpen(false);
        actions.resetForm();
        setPhoto('');
        await getMembers();
        setIsSuccessAlert(true);
        setSuccessMessage('Member added Successfully');
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      }
    } catch (error) {
      console.error('Caught error:', error);
      setIsFailureAlert(true);
      setFailureMessage('Failed to add Member');
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
      }, 5000);
    } finally {
      setLoading(false);
    }
  };
  


  const handleUpdateMember = async (values, actions) => {
        if(values.trainer_id === null){ 
            values.trainer_id = '';
        }
        if (isLocationScoped) {
          values.location_id = scopedLocationId;
        }
        if (!values.location_id) {
          setIsFailureAlert(true);
          setFailureMessage('Location is required for members.');
          setIsPopupOpen(true);
          setTimeout(() => {
            setIsPopupOpen(false);
          }, 5000);
          return;
        }
        const formData = new FormData();

        Object.keys(values).forEach((key) => {
            if (key === 'photo' && values[key]) {
              // If file object then add file else let it use the string
              if (values[key] instanceof Blob || values[key] instanceof File) {
                console.log('Appending photo file:', values[key]);
                formData.append('photo', values[key], 'photo.jpg');
              } else {
                formData.append(key, values[key]);
              }
            } else {
              formData.append(key, values[key]); 
            }
          });
        setLoading(true)
      const requestOptions = {
          method: "POST",
        //   headers: {
        //       "Content-Type": "application/json",
        //   },
          body: formData,
      };

      try {
          const response = await fetch(BASE_URL + `members/update-member/${memberToUpdate}`, requestOptions);

          if (!response.ok) {
              console.error('Response not ok:', response);
              setIsFailureAlert(true)
              setFailureMessage('Failed to Update Member' + (response.machineMessage ? ` - Machine Response: ${response.machineMessage}` : ''))
              setIsPopupOpen(true)
              setTimeout(() => {
                  setIsPopupOpen(false)
              }, 5000)
          } else {
              const data = await response.json();
              actions.resetForm()
              setIsUpdateModalOpen(false)
              await getMembers()
              setIsSuccessAlert(true)
              const machineMessage = data.machineMessage;
              setSuccessMessage('Member Updated Successfully' + (machineMessage ? ` - In Machines: ${machineMessage}` : ''))
              setIsPopupOpen(true)
              setTimeout(() => {
                  setIsPopupOpen(false)
              }, 5000)
          }
      } catch (error) {
          console.error('Caught error:', error);
          setIsFailureAlert(true)
          setFailureMessage('Failed to Update Member' + (error.machineMessage ? ` - Machine Response: ${error.machineMessage}` : ''))
          setIsPopupOpen(true)
          setTimeout(() => {
              setIsPopupOpen(false)
          }, 5000)
      } finally {
          setLoading(false);
      }

}

async function restoreMember () { 
  console.log('inside restore model');
  
  setButtonLoading(true);

  const body = {
    subStartDate: selectedSubStartDate,
};
  const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    };
  
    try {
      const response = await fetch(BASE_URL + `members/restore-member/${memberToRestore._id}`, requestOptions);
      console.log('response: ' , response);
      if (!response.ok) {
        console.log('got in restore failure');
        const data = await response.json();
        console.error('Response not ok:', data);
        setIsFailureAlert(true);
        setFailureMessage(data.message + (data.machineMessage ? ` - Machine Response: ${data.machineMessage}` : ''));
        setIsPopupOpen(true);
        toggleRestoreModal();
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      } else {
        console.log('got in restore success');
        const data = await response.json();
        console.log('data: ', data);
        const voucher_id =
          data.trainerVoucher?.voucher?._id ?? data.voucher?.voucher?._id;
        if (!voucher_id) {
          throw new Error('Restore succeeded but no voucher id was returned');
        }
        console.log("voucher_id: ", voucher_id);
        navigate(`/voucher/${voucher_id}`)
        await getMembers();
        // toggleRestoreModal()
        // setIsSuccessAlert(true)
        // setSuccessMessage('Member Reactivated Successfully')
        // setIsPopupOpen(true)
        
        // setTimeout(() => {
        //     setIsPopupOpen(false)
        // }, 5000)
      }
    } catch (error) {
        console.log('got in restore error');
      toggleRestoreModal()
      await getMembers()
        setIsFailureAlert(true)
        setFailureMessage('Member not Reactivated Successfully' + error + (error.machineMessage ? ` - Machine Response: ${error.machineMessage}` : ''))
        setIsPopupOpen(true)
        setTimeout(() => {
            setIsPopupOpen(false)
        }, 5000)
    } finally {
      setButtonLoading(false);
    }
}

  async function deleteMember () {
      const requestOptions = {
          method: "DELETE",
          headers: {
              "Content-Type": "application/json",
          },
      };
      setButtonLoading(true);
      setLoading(true)
      await fetch(BASE_URL + `members/delete-member/${memberToDelete}` , requestOptions)
      .then( async (response) => {
        const responseData = await response.json()
        if(responseData) {
            await getMembers()
            setIsDeleteModalOpen(false)
            setIsSuccessAlert(true)
            setSuccessMessage('Member deleted Successfully')
            setIsPopupOpen(true)
            setTimeout(() => {
                setIsPopupOpen(false)
            }, 5000)
        }
    })
      .catch((error) => {
          console.log(error)
          setIsFailureAlert(true)
          setFailureMessage('Failed to delete Member')
          setIsPopupOpen(true)
          setTimeout(() => {
              setIsPopupOpen(false)
          }, 5000)
      })
      .finally(() => {
        setLoading(false)
          setButtonLoading(false)
      });
  }

    function toggleAddModal() {
      setIsAddModalOpen(!isAddModalOpen)
      setPhoto('')
      handleCloseCamera()
      resetForm()
  }
  function toggleViewModal() {
      setIsViewModalOpen(!isViewModalOpen)
      resetForm()
  }

  function toggleUpdateModal() {
      setIsUpdateModalOpen(!isUpdateModalOpen)
      setPhoto('')
      setFieldValue('photo' , '')
      handleCloseCamera()
      resetForm()
  }
  function toggleDeleteModal() {
      setIsDeleteModalOpen(!isDeleteModalOpen)
  }

  function toggleEmailModal() {
    setEmailData({ subject: "", html: "" });
    if (editorRef.current) {
      editorRef.current.editor.loadHTML(""); 
    }
    setIsEmailModalOpen(!isEmailModalOpen)
}

  function toggleSmsModal() {
    if (isSmsModalOpen) {
      if (smsSearchDebounceRef.current) clearTimeout(smsSearchDebounceRef.current);
      if (smsSearchAbortRef.current) smsSearchAbortRef.current.abort();
      setSmsMessage("");
      setSmsSelectedMembers([]);
      setSmsMemberOptions([]);
      setSmsInputValue("");
      setSmsOptionsPage(1);
      setSmsOptionsHasMore(false);
      setSmsMemberFilters({ ...SMS_FILTER_DEFAULTS });
      smsSearchQueryRef.current = "";
    }
    setIsSmsModalOpen(!isSmsModalOpen);
  }

  function mapSmsMemberOption(m) {
    return {
      _id: m._id,
      name: m.name,
      member_id: m.member_id,
      phone: m.phone || "",
      company_id: m.company_id?._id || m.company_id,
      location_id: m.location_id?._id || m.location_id,
      is_active: m.is_active,
    };
  }

  function buildSmsDropdownParams(query, page) {
    const params = new URLSearchParams({
      search: query.trim(),
      page: String(page),
      limit: String(SMS_DROPDOWN_PAGE_SIZE),
    });
    if (role === "Admin" && company_id) {
      params.set("company_id", company_id);
    } else if (role === "ClubAdmin" && location_id) {
      params.set("location_id", location_id);
    } else if (isDynamicStaffRole(role) && location_id) {
      params.set("location_id", location_id);
    } else {
      if (company_id) params.set("company_id", company_id);
      if (location_id) params.set("location_id", location_id);
    }
    return params;
  }

  async function fetchSmsMemberOptions(query = "", page = 1, append = false) {
    if (!role) return;

    if (smsSearchAbortRef.current) {
      smsSearchAbortRef.current.abort();
    }
    const controller = new AbortController();
    smsSearchAbortRef.current = controller;
    smsSearchQueryRef.current = query.trim();

    setSmsLoadingOptions(true);
    try {
      const params = buildSmsDropdownParams(query, page);
      const response = await fetch(`${BASE_URL}members/search-dropdown?${params}`, {
        signal: controller.signal,
      });
      const data = await response.json();
      if (smsSearchQueryRef.current !== query.trim()) return;

      const members = (data.members || []).map(mapSmsMemberOption);
      const pagination = data.pagination || {};
      setSmsMemberOptions((prev) => {
        if (!append) return members;
        const seen = new Set(prev.map((m) => String(m._id)));
        const merged = [...prev];
        for (const m of members) {
          if (!seen.has(String(m._id))) merged.push(m);
        }
        return merged;
      });
      setSmsOptionsPage(page);
      setSmsOptionsHasMore(Boolean(pagination.hasMore));
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Failed to load SMS member options:", error);
        if (!append) {
          setSmsMemberOptions([]);
          setSmsOptionsHasMore(false);
        }
      }
    } finally {
      if (!controller.signal.aborted) {
        setSmsLoadingOptions(false);
      }
    }
  }

  function scheduleSmsMemberSearch(query) {
    if (smsSearchDebounceRef.current) clearTimeout(smsSearchDebounceRef.current);
    smsSearchDebounceRef.current = setTimeout(() => {
      fetchSmsMemberOptions(query, 1, false);
    }, 350);
  }

  function loadMoreSmsMemberOptions() {
    if (!smsOptionsHasMore || smsLoadingOptions) return;
    fetchSmsMemberOptions(smsInputValue, smsOptionsPage + 1, true);
  }

  function showSmsModal() {
    setSmsMessage("");
    setSmsSelectedMembers([]);
    setSmsMemberOptions([]);
    setSmsInputValue("");
    setSmsOptionsPage(1);
    setSmsOptionsHasMore(false);
    setSmsMemberFilters({ ...SMS_FILTER_DEFAULTS });
    setIsSmsModalOpen(true);
    // Initial browse page — further pages load via infinite scroll in the dropdown
    fetchSmsMemberOptions("", 1, false);
  }

  const smsHasBulkFilter = Object.values(smsMemberFilters).some(Boolean);

  function toggleSmsBulkFilter(key) {
    setSmsSelectedMembers([]);
    setSmsMemberFilters((prev) => {
      if (key === "all") {
        const nextAll = !prev.all;
        return {
          ...SMS_FILTER_DEFAULTS,
          all: nextAll,
        };
      }
      return {
        ...prev,
        all: false,
        [key]: !prev[key],
      };
    });
  }

  function clearAllSmsMembers() {
    setSmsSelectedMembers([]);
    setSmsMemberFilters({ ...SMS_FILTER_DEFAULTS });
  }

  const sendCustomSms = async () => {
    const trimmed = smsMessage.trim();
    if (!trimmed) {
      setIsFailureAlert(true);
      setFailureMessage("Enter an SMS message");
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
        setIsFailureAlert(false);
      }, 3000);
      return;
    }
    if (trimmed.length > CUSTOM_SMS_MAX_LENGTH) {
      setIsFailureAlert(true);
      setFailureMessage(`Message must be at most ${CUSTOM_SMS_MAX_LENGTH} characters`);
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
        setIsFailureAlert(false);
      }, 3000);
      return;
    }
    if (!smsHasBulkFilter && !smsSelectedMembers.length) {
      setIsFailureAlert(true);
      setFailureMessage("Select members or a group filter (All / Active / …)");
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
        setIsFailureAlert(false);
      }, 3000);
      return;
    }

    const resolvedCompanyId =
      company_id ||
      smsSelectedMembers[0]?.company_id;
    if (!resolvedCompanyId) {
      setIsFailureAlert(true);
      setFailureMessage("Company is required to send SMS");
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
        setIsFailureAlert(false);
      }, 3000);
      return;
    }

    if (!smsHasBulkFilter) {
      const companyIds = new Set(
        smsSelectedMembers.map((m) => String(m.company_id || resolvedCompanyId))
      );
      if (companyIds.size > 1) {
        setIsFailureAlert(true);
        setFailureMessage("Selected members must belong to the same company");
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
          setIsFailureAlert(false);
        }, 3000);
        return;
      }
    }

    const payload = {
      message: trimmed,
      company_id: resolvedCompanyId,
      ...(role === "ClubAdmin" && location_id ? { location_id } : {}),
      ...(smsHasBulkFilter
        ? { member_filters: smsMemberFilters }
        : { member_ids: smsSelectedMembers.map((m) => m._id) }),
    };

    setSmsSending(true);
    try {
      const response = await fetch(BASE_URL + "members/send-custom-sms", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        setIsFailureAlert(true);
        setFailureMessage(data.message || "Failed to queue SMS");
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
          setIsFailureAlert(false);
        }, 5000);
        return;
      }

      const skipped = data.skipped?.length || 0;
      const successText =
        skipped > 0
          ? `Queued for ${data.queued} member(s); ${skipped} skipped (invalid/missing phone)`
          : `Queued SMS for ${data.queued} member(s)`;

      toggleSmsModal();
      setIsSuccessAlert(true);
      setSuccessMessage(successText);
      setIsPopupOpen(true);
      setTimeout(() => setIsPopupOpen(false), 5000);
    } catch (error) {
      console.error("sendCustomSms error:", error);
      setIsFailureAlert(true);
      setFailureMessage("Failed to queue SMS");
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
        setIsFailureAlert(false);
      }, 5000);
    } finally {
      setSmsSending(false);
    }
  };

  const sendCustomizedEmail = async() => {
    console.log("Sending Email:", emailData); 
    if(emailData.subject === '' || emailData.html === '') {
        setIsFailureAlert(true)
        setFailureMessage('Enter Both Subject and Content Fields'); 
        setIsPopupOpen(true);
        setTimeout(() => {
            setIsPopupOpen(false)
            setIsFailureAlert(false)
        } , 3000)
        return;
    }

    const data = {
        to: member.email,
        subject: emailData.subject,
        html: emailData.html,
    }

    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };
    
    try {
        const response = await fetch(BASE_URL + `users/customizedEmail`, requestOptions);

        console.log('Response status:', response.status);
        if (!response.ok) {
            console.error('Response not ok:', response);
            setIsFailureAlert(true)
            setFailureMessage('Failed to Send Email')
            toggleEmailModal(); 
        } else {
            const responseData = await response.json();
            console.log('Response data:', responseData);
            toggleEmailModal(); 
            setIsSuccessAlert(true)
            setSuccessMessage('Email Send Successfully')
            isPopupOpen(true)
            setTimeout(() => {
                setIsPopupOpen(false)
            } , 5000)
        }
    } catch (error) {
        console.error('Caught error:', error);
        setIsFailureAlert(true) 
        setFailureMessage('Failed to Send Email')
        setIsPopupOpen(true)
        setTimeout(() => {
            setIsPopupOpen(false)
        } , 5000)
    } finally {
        // setLoading(false);
    }
  };

  function toggleRestoreModal() {
    setSelectedSubStartDate('')
    setIsRestoreModalOpen(!isRestoreModalOpen)
}

function toggleAdvanceModal() {
    setIsAdvanceModalOpen(!isAdvanceModalOpen)
}
function toggleChargesModal(){
    setIsChargesModalOpen(!isChargesModalOpen)
}
function togglePackageModal(){
  setIsPackageModalOpen(!isPackageModalOpen)
}

function toggleTrainerModal(){

  setIsTrainerModalOpen(!isTrainerModalOpen)
}


  function showAddModal(id) {
      setIsAddModalOpen(true);
  }
  function showViewModal(id) {
      getMemberByID(id);
      setIsViewModalOpen(true);
  }

  function showEmailModal(id) {
    getMemberByID(id);
    setIsEmailModalOpen(true);
}

  function showUpdateModal(member) {
    //   getMemberByID(member._id);
        console.log("member" , member);
        setMemberPackageAmount(member?.package_id?.membership_fee)
        setMemberToUpdate(member?._id);
        // TODO: Fix Image issues
        setPhoto(encodedImagesURI(member?.photo) || null)
        // member.photo = member?.photo ? base64ToBlob(member?.photo) : null;
        // setMember(member)
        let endRenewDate = null;
        if(!member.subscription.renewed_date ) {
            endRenewDate = new Date(member.subscription?.start_date);
            endRenewDate.setDate(endRenewDate.getDate() + 15);
        } else {
            endRenewDate = new Date(member.subscription?.renewed_date);
            endRenewDate.setDate(endRenewDate.getDate() + 15);
        }
        setValues({...member , location_id: member?.location_id?._id , package_id: member?.package_id?._id , trainer_id: member?.trainer_id?._id , endRenewDate, date_of_birth: member?.date_of_birth ? new Date(member?.date_of_birth).toISOString().split('T')[0] : ''});
        
      setIsUpdateModalOpen(true);
  }
  function showDeleteModal(id) {
      setMemberToDelete(id);
      setIsDeleteModalOpen(true);
  }

  function showAdvancePaymentModal(member) {
    setMemberToAdvance(member);
    setIsAdvanceModalOpen(true);
}
  
function showAdvanceDamageCharges(member){
    setMemberToAdvance(member);
    setIsChargesModalOpen(true);
}
  function showRestoreModal(member) {
    setMemberToRestore(member);
    setIsRestoreModalOpen(true);
}
function showChangePackage(member){
  const packageId = member?.package_id ? member.package_id._id : '';
  setSelectedPackage(packageId)
  setMember(member)
  setIsPackageModalOpen(true);
}


function showChangeTrainer(member){
  const trainerId = member?.trainer_id?._id || null;
  setSelectedTrainer(trainerId)
  setIsTrainer(member.is_trainer)
  setMember(member)
  setIsTrainerModalOpen(true);
}

function showResetPasswordModal(member) {
  setMemberForPasswordReset(member);
  setIsResetPasswordModalOpen(true);
}

const handleExport = (filteredMembers , filter) => {
    Report(filteredMembers , filter)
}

// Export all members without filters or pagination
const handleExportAll = async (allMembers) => {
  if (useServerPagination) {
    await downloadMembersExcel("all");
    return;
  }
  try {
    Report(allMembers || [], {});
  } catch (error) {
    console.error('Error exporting all members:', error);
    alert('An error occurred while exporting. Please try again.');
  }
};

const handleExportWithFilters = async (filteredMembersArg, filterValue) => {
  if (useServerPagination) {
    await downloadMembersExcel("filtered");
    return;
  }
  Report(filteredMembersArg || [], filterValue || filterParams || {});
};

const handleExportCurrentView = async (paginatedMembers, filterValue) => {
  if (useServerPagination) {
    await downloadMembersExcel("page");
    return;
  }
  Report(paginatedMembers || [], filterValue || filterParams || {});
};

const base64ToBlob = (base64String) => {
  // Check if base64String exists and is a string
  if (!base64String || typeof base64String !== 'string') {
    console.error('Invalid base64 string input');
    return null;
  }

  try {
    const arr = base64String.split(",");
    if (!arr || arr.length < 2) {
      console.error('Invalid base64 format');
      return null;
    }

    const mimeMatch = arr[0].match(/:(.*?);/);
    if (!mimeMatch || mimeMatch.length < 2) {
      console.error('Could not extract MIME type');
      return null;
    }

    const mime = mimeMatch[1];
    const bstr = atob(arr[1]); // Decode Base64
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  } catch (error) {
    console.error('Error converting base64 to blob:', error);
    return null;
  }
};

  const handleSelectPhotoClick = (e) => {
    e.preventDefault();
    if (selectPhotoRef.current) {
      selectPhotoRef.current.click();
    } else {
      console.error('selectPhotoRef is not properly initialized.');
    }
  };

  const handleTakePhotoClick = async (e) => {
    e.preventDefault();

    if (cameraStream) {
        cameraStream.getTracks().forEach((track) => track.stop());
        setCameraStream(null);
      }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      setCameraStream(stream);
  
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
  
        videoRef.current.oncanplay = () => {
          videoRef.current.play();
        };
      } else {
        console.error('Video element is not properly initialized');
      }
    } catch (error) {
      console.error("Error accessing the camera:", error);
    }
  };

  const handleCloseCamera = () => {
    if (cameraStream) {
      cameraStream.getTracks().forEach((track) => track.stop());
      setCameraStream(null);
    }
  };
  

  const handleCapturePhoto = () => {
    if (canvasRef.current && videoRef.current) {
        
      const context = canvasRef.current.getContext("2d");
      canvasRef.current.width = videoRef.current.videoWidth;
      canvasRef.current.height = videoRef.current.videoHeight;
      context.drawImage(
        videoRef.current,
        0,
        0,
        videoRef.current.videoWidth,
        videoRef.current.videoHeight
      );

      // Get the photo data as a URL
      const photoData = canvasRef.current.toDataURL("image/png");
      const photoBlob = base64ToBlob(photoData);
      setFieldValue("photo", photoBlob);
      setPhoto(photoData)

      // Stop the camera stream
      if (cameraStream) {
        cameraStream.getTracks().forEach((track) => track.stop());
        setCameraStream(null);
      }
    }
  };

  const calculateAge = (dateOfBirth) => {
    if (!dateOfBirth) return '';
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age.toString();
  };

    const {values , touched , errors , handleBlur , handleChange , handleSubmit , setValues , resetForm , setFieldValue} = useFormik({
      initialValues: {
        id:'',
        name: '',
        phone: '',
        photo: null,
        email:'',
        password: '',
        address: '',
        is_trainer: false,
        trainer_id: '',
        country: '',
        state:'',
        city: '',
        postal_code: '',
        cnic:'',
        age: '',
        gender: 'male',
        height:'',
        height_units: 'ft',
        weight: '',
        weight_units: 'kg',
        emergency_contact: '',
        emergency_contact_no: '',
        disease: '',
        company_id: '',
        // discount: 0,
        location_id: isLocationScoped ? scopedLocationId : '' ,
        package_id:'',
        emergency_relation:'',
        // discount_remarks:'',
        role: 'User',
        update_package : false,
        update_Trainer : false,
        date_of_birth: new Date().toISOString().split('T')[0], // Default to today's date
        registration_free: true,
        renewal_day: "",
        has_dynamic_subscription_renewal_day: false,

      },
      enableReinitialize: true,
      validationSchema: memberSchema(isUpdateModalOpen , member_package_amount),
      onSubmit: (values, actions) => {
          if(isAddModalOpen){
              handleAddMember(values, actions); // Call the external function
          } else if(isUpdateModalOpen) {
              handleUpdateMember(values, actions);
          }
      },
  })

  const handleRipple = (e) => {
    const button = e.currentTarget;

    const ripple = document.createElement('span');
    
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;
    
    ripple.style.width = ripple.style.height = `${diameter}px`;
    ripple.style.left = `${e.clientX - button.offsetLeft - radius}px`;
    ripple.style.top = `${e.clientY - button.offsetTop - radius}px`;
    
    ripple.classList.add('ripple');
    
    const existingRipple = button.querySelector('.ripple');
    if (existingRipple) {
      existingRipple.remove();
    }

    button.appendChild(ripple);
  };

//   const addTabData = () => {
//     const tabData = [
//         { key: 'inactive', label: 'Inactive Members', members: inactive_members},
//         { key: 'active', label: 'Active Members', members: active_members},
//         { key: 'all', label: 'All Members', members: members},
//         { key: 'new', label: 'New Members', members: new_members},
//         { key: 'restored', label: 'Restored Members', members: restored_members},
//       ];
//   }

  const orderedTabs = MEMBER_TAB_ORDER.map((key) =>
    tabData.find((tab) => tab.key === key)
  ).filter(Boolean);

  const selectTab = (key) => {
    setTabType(key);
    if (useServerPagination) {
      getMembers(1, key, pagination.limit, searchQuery, filterParams, {
        sortBy,
        sortDir,
      }, { manageListFetching: true });
    }
  };

  const rosterStats = [
    {
      key: "all",
      label: "All members",
      value: counts.all ?? orderedTabs.find((t) => t.key === "all")?.count ?? 0,
      icon: <GroupsOutlinedIcon />,
      accent: "#033b51",
      featured: true,
    },
    {
      key: "active",
      label: "Active",
      value: counts.active ?? active_members,
      icon: <CheckCircleOutlineOutlinedIcon />,
      accent: "#059669",
    },
    {
      key: "inactive",
      label: "Inactive",
      value: counts.inactive ?? inactive_members,
      icon: <PersonOffOutlinedIcon />,
      accent: "#D71920",
    },
    {
      key: "new",
      label: "New",
      value: counts.new ?? new_members,
      icon: <PersonAddOutlinedIcon />,
      accent: "#F7931E",
    },
    {
      key: "restored",
      label: "Returning",
      value: counts.restored ?? restored_members,
      icon: <RestoreIcon />,
      accent: "#022A3A",
    },
    {
      key: "personal_coaching",
      label: "Coaching",
      value: counts.personal_coaching ?? 0,
      icon: <FitnessCenterIcon />,
      accent: "#D71920",
    },
  ];

  return (
    <>
    <div className="m-5 space-y-6">
      <PageHeader
        title="Members"
        subtitle="Search the roster, filter by status, and open a full member dossier."
        actions={
          <div className="flex flex-wrap items-center gap-2">
            <div className="relative">
              <FontAwesomeIcon icon={faSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-gx-ink-soft" />
              <input
                type="text"
                placeholder="Search name, ID, phone..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="border border-gx-border bg-gx-surface rounded-gx-control py-2 pl-10 pr-3 outline-0 w-56 md:w-72 text-sm"
              />
            </div>
            <button
              type="button"
              className="gx-cta-secondary gap-2"
              onClick={() => setOpen(true)}
            >
              <BarChartIcon fontSize="small" />
              Stats
            </button>
            <button
              type="button"
              className="gx-cta-secondary"
              onClick={showSmsModal}
            >
              Send SMS
            </button>
            {hasPermission(getSessionUser(), 'members:create') && (
            <button
              type="button"
              className="gx-cta"
              onClick={showAddModal}
            >
              Add Member
            </button>
            )}
          </div>
        }
      />

      <MemberExportModal open={exportPreparing} message={exportMessage} />

      {rosterLoading ? (
        <MembersRosterSkeleton />
      ) : (
        <>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
        {rosterStats.map((stat) => (
          <StatCard
            key={stat.key}
            featured={stat.featured}
            label={stat.label}
            value={stat.value}
            icon={stat.icon}
            accent={stat.accent}
            hint={tabType === stat.key ? "Showing this roster" : "View roster"}
            onClick={() => selectTab(stat.key)}
          />
        ))}
      </div>

      <div className="flex border-b border-gx-border overflow-x-auto">
        {orderedTabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`${tabType === tab.key ? "gx-tab-active" : "gx-tab"} whitespace-nowrap`}
            onClick={() => selectTab(tab.key)}
          >
            {tab.label}
            {tab.count != null ? (
              <span className="ml-2 text-xs font-semibold opacity-70">{tab.count}</span>
            ) : null}
          </button>
        ))}
      </div>

        {
            tabData.map((tab , index) => (
                tabType === tab.key && 
                <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx overflow-hidden animate-fadeIn" key={tab.key}>
                    <RenderTable
                        key={index}
                        members={useServerPagination ? members : tab.members}
                        showRestoreModal={showRestoreModal}
                        showViewModal={showViewModal}
                        showEmailModal={showEmailModal}
                        showUpdateModal={showUpdateModal}
                        showDeleteModal={showDeleteModal}
                        showAdvancePaymentModal={showAdvancePaymentModal}
                        showAdvanceDamageCharges={ showAdvanceDamageCharges}
                        showChangePackage={showChangePackage}
                        showChangeTrainer={showChangeTrainer}
                        showResetPasswordModal={showResetPasswordModal}
                        packages = {packages}
                        handleExport = {handleExport}
                        onExportAll={handleExportAll}
                        onExportWithFilters={handleExportWithFilters}
                        onExportCurrentView={handleExportCurrentView}
                        searchQuery={searchQuery}
                        sortBy={sortBy}
                        sortDir={sortDir}
                        onSortChange={handleSortChange}
                        showTrainerColumns={tabType === 'personal_coaching'}
                        isListFetching={useServerPagination ? listFetching : false}
                        filterParams={useServerPagination ? filterParams : undefined}
                        exportHasFilters={useServerPagination ? memberExportHasFiltersApplied() : undefined}
                        serverPagination={useServerPagination ? {
                          total: pagination.total,
                          page: pagination.page - 1,
                          rowsPerPage: pagination.limit,
                          onPageChange: (e, newPage) => getMembers(newPage + 1, tabType, pagination.limit, searchQuery, filterParams, { sortBy, sortDir }, { manageListFetching: true }),
                          onRowsPerPageChange: (e) => {
                            const newLimit = parseInt(e.target.value, 10);
                            setPagination((prev) => ({ ...prev, limit: newLimit === -1 ? 1000 : newLimit, page: 1 }));
                            getMembers(1, tabType, newLimit === -1 ? 1000 : newLimit, searchQuery, filterParams, { sortBy, sortDir }, { manageListFetching: true });
                          },
                        } : undefined}
                        onApplyFilters={useServerPagination ? (filters) => {
                          setFilterParams(filters);
                          setPagination((prev) => ({ ...prev, page: 1 }));
                          getMembers(1, tabType, pagination.limit, searchQuery, filters, { sortBy, sortDir }, { manageListFetching: true });
                        } : undefined}
                        onClearFilters={useServerPagination ? () => {
                          const cleared = {
                            package_id: "",
                            gender: "",
                            from_date: "",
                            to_date: "",
                            is_active: "",
                            fee_status: "",
                          };
                          setFilterParams(cleared);
                          setPagination((prev) => ({ ...prev, page: 1 }));
                          getMembers(1, tabType, pagination.limit, searchQuery, cleared, { sortBy, sortDir }, { manageListFetching: true });
                        } : undefined}
                        tabType={tabType}
                    />
                </Box>
            ))
        }
        </>
      )}
    </div>
<CustomModal isModal={isAddModalOpen || isUpdateModalOpen} handleModal={() => {
    if (isAddModalOpen) {
        toggleAddModal();
    } else if (isUpdateModalOpen) {
        toggleUpdateModal();
    }
}} size='2xl' index='z-50'>
      <h1 className='font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2'>
        {
            isAddModalOpen ? 'Add Member' : 'Update Member' 
        }
    </h1>
    <form onSubmit={handleSubmit} className='text-gx-ink-soft m-5' autoComplete='off'>
        <h1 className='font-bold text-lg text-gx-ink-soft pb-2'>Member Info:</h1>
        <div className="flex justify-between gap-5 mt-4">
            <div className='w-full'>
                <label>Profile Photo (Required Format: .jpg, .jpeg)</label>
                <div className='w-full flex gap-2 mx-5 mt-3'>
                    <button className='border border-gx-border hover:border-gx-border hover:text-gx-ink-soft bg-gx-canvas hover:bg-gx-border px-2 py-1 outline-0'
                     onClick={handleSelectPhotoClick}>
                        Select Photo
                    </button>
                    {!cameraStream && (
                    <button
                        className="border border-gx-border hover:border-gx-border hover:text-gx-ink-soft bg-gx-canvas hover:bg-gx-border px-2 py-1 outline-0"
                        onClick={handleTakePhotoClick}
                    >
                        Take Photo
                    </button>
                    )}
                     {cameraStream && (
                        <button
                        type="button"
                        className="border border-gx-border hover:border-gx-border hover:text-gx-ink-soft bg-red-100 hover:bg-red-200 px-2 py-1 outline-0"
                        onClick={handleCloseCamera}
                        >
                        Close Camera
                        </button>
                    )}
                    {/* <button className='border border-gx-border hover:border-gx-border hover:text-gx-ink-soft bg-gx-canvas hover:bg-gx-border px-2 py-1 outline-0' onClick={handleTakePhotoClick}>Take Photo</button> */}
                </div>
                <input
                    type="file"
                    name="photo"
                    className="hidden"
                    // value={base64ToBlob(member.photo)}
                    ref={selectPhotoRef}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const reader = new FileReader();
                        reader.onload = () => {
                          try {
                            const base64String = reader.result;
                            if (typeof base64String === 'string') {
                              const photoBlob = base64ToBlob(base64String);
                              if (photoBlob) {
                                setFieldValue("photo", photoBlob);
                                setPhoto(base64String);
                              }
                            } else {
                              console.error('FileReader result is not a string');
                            }
                          } catch (error) {
                            console.error('Error processing file:', error);
                          }
                        };
                        reader.onerror = () => {
                          console.error("Error reading file: ", reader.error);
                        };
                        reader.readAsDataURL(file);
                        e.target.value = "";
                      } else {
                        console.warn("No file selected");
                      }
                    }}
                    onBlur={handleBlur}
                    />
                

                {cameraStream && (
                    <div className="flex flex-col items-center">
                        <video ref={videoRef} className="border mb-2" />
                        <button
                        type="button"
                        className="border border-gx-border hover:border-gx-border hover:text-gx-ink-soft bg-gx-canvas hover:bg-gx-border px-2 py-1 outline-0"
                        onClick={handleCapturePhoto}
                        >
                        Capture Photo
                        </button>
                    </div>
                    )}

                  

                    {photo && (
                    <div className="mt-4">
                        <label>Captured Photo:</label>
                        <img
                        src={photo}
                        alt="Captured"
                        className="border mt-2"
                        />
                    </div>
                    )}

                    {/* Hidden canvas for photo capture */}
                    <canvas ref={canvasRef} className="hidden" />
                {touched.photo && errors.photo ? <p className='text-red-500 pl-2 italic'>{errors.photo}</p> : null}
            </div>
        </div>
       <div className='flex flex-col md:flex-row justify-between gap-5 mt-4'>
  <div className='w-full'>
    <label>Name <span className='text-red-600'>*</span></label>
    <input type='text' name='name' placeholder='Enter Name'
      value={values.name}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ' + (errors.name && touched.name ? 'border-red-600' : '')}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    {touched.name && errors.name ? <p className='text-red-500 pl-2 italic'>{errors.name}</p> : null}
  </div>
  <div className='w-full'>
    <label>Phone <span className='text-red-600'>*</span></label>
    <PhoneInput
      name='phone'
      country={"pk"}
      value={values.phone}
      onChange={(value) => setFieldValue("phone", value)}
      inputStyle={{ width: "100%" }}
    />
    {touched.phone && errors.phone ? <p className='text-red-500 pl-2 italic'>{errors.phone}</p> : null}
  </div>
</div>

<div className='flex flex-col md:flex-row justify-between gap-5 mt-5'>
  {/* Date Of Birth */}
  <div className='w-full'>
    <label>Date Of Birth <span className='text-red-600'>*</span></label>
    <input type='date' name='date_of_birth' placeholder='Enter Date Of Birth'
      value={values.date_of_birth}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ' + (errors.date_of_birth && touched.date_of_birth ? 'border-red-600' : '')}
      onChange={(e) => {
        const dob = e.target.value;
        handleChange(e);
        setFieldValue("age", calculateAge(dob)); // Calculate age based on date of birth
      }}
      onBlur={handleBlur}
    />
    {touched.date_of_birth && errors.date_of_birth ? <p className='text-red-500 pl-2 italic'>{errors.date_of_birth}</p> : null}
  </div>
  <div className='w-full'>
    <label>Age <span className='text-red-600'>*</span></label>
    <input type='number' name='age' placeholder='Enter Age'
      value={values.age}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ' + (errors.age && touched.age ? 'border-red-600' : '')}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={true}
    />
    {touched.age && errors.age ? <p className='text-red-500 pl-2 italic'>{errors.age}</p> : null}
  </div>
</div>

<div className='flex flex-col md:flex-row justify-between gap-5 mt-5'>
  <div className='w-full'>
    <label>Gender <span className='text-red-600'>*</span></label>
    <select name='gender'
      value={values.gender}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ' + (errors.gender && touched.gender ? 'border-red-600' : '')}
      onChange={handleChange}
      onBlur={handleBlur}
    >
      <option value='male'>Male</option>
      <option value='female'>Female</option>
      {/* <option value='other'>Other</option> */}
    </select>
    {touched.gender && errors.gender ? <p className='text-red-500 pl-2 italic'>{errors.gender}</p> : null}
  </div>
    <div className='w-full'>
    <label>CNIC <span className='text-red-600'>*</span></label>
    <input type='text' name='cnic' placeholder='Enter CNIC'
      value={values.cnic}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ' + (errors.cnic && touched.cnic ? 'border-red-600' : '')}
      onChange={(e) => {
        const numericValue = e.target.value.replace(/\D/g, "");
        handleChange({ target: { name: "cnic", value: numericValue } });
      }}
      onBlur={handleBlur}
      maxLength={13}
    />
    {touched.cnic && errors.cnic ? <p className='text-red-500 pl-2 italic'>{errors.cnic}</p> : null}
  </div>
</div>

<div className='flex flex-col md:flex-row justify-between gap-5 mt-5'>
  <div className='w-full'>
    <label>Height:</label>
    <input type='number' name='height' placeholder='Enter Height'
      value={values.height || ''}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ' + (errors.height && touched.height ? 'border-red-600' : '')}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    {touched.height && errors.height ? <p className='text-red-500 pl-2 italic'>{errors.height}</p> : null}
  </div>
  <div className='w-full'>
    <label>Height Units:</label>
    <select name='height_units'
      value={values.height_units}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ' + (errors.height_units && touched.height_units ? 'border-red-600' : '')}
      onChange={handleChange}
      onBlur={handleBlur}
    >
      <option value='ft'>Feet (ft)</option>
      <option value='cm'>Centimeter (cm)</option>
    </select>
    {touched.height_units && errors.height_units ? <p className='text-red-500 pl-2 italic'>{errors.height_units}</p> : null}
  </div>
</div>

<div className='flex flex-col md:flex-row justify-between gap-5 mt-5'>
  <div className='w-full'>
    <label>Weight:</label>
    <input type='number' name='weight' placeholder='Enter Weight'
      value={values.weight}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ' + (errors.weight && touched.weight ? 'border-red-600' : '')}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    {touched.weight && errors.weight ? <p className='text-red-500 pl-2 italic'>{errors.weight}</p> : null}
  </div>
  <div className='w-full'>
    <label>Weight Units:</label>
    <select name='weight_units'
      value={values.weight_units}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ' + (errors.weight_units && touched.weight_units ? 'border-red-600' : '')}
      onChange={handleChange}
      onBlur={handleBlur}
    >
      <option value='kg'>Kilogram (kg)</option>
      <option value='lb'>Pound (lb)</option>
    </select>
    {touched.weight_units && errors.weight_units ? <p className='text-red-500 pl-2 italic'>{errors.weight_units}</p> : null}
  </div>
</div>

  <div className='w-full mt-5'>
    <label>Disease/Medical Condition:</label>
    <input type='text' name='disease' placeholder='Enter Disease/Medical Condition'
      value={values.disease}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ' + (errors.disease && touched.disease ? 'border-red-600' : '')}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    {touched.disease && errors.disease ? <p className='text-red-500 pl-2 italic'>{errors.disease}</p> : null}
  </div>

<h1 className='font-bold text-lg text-gx-ink-soft py-2 border-t mt-5'>Emergency Contact Details:</h1>
<div className='flex flex-col md:flex-row justify-between gap-5 mt-5'>
  <div className='w-full'>
    <label>Emergency Contact Name <span className='text-red-600'>*</span></label>
    <input type='text' name='emergency_contact' placeholder='Enter Emergency Contact Name'
      value={values.emergency_contact}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ' + (errors.emergency_contact && touched.emergency_contact ? 'border-red-600' : '')}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    {touched.emergency_contact && errors.emergency_contact ? <p className='text-red-500 pl-2 italic'>{errors.emergency_contact}</p> : null}
  </div>
  <div className='w-full'>
    <label>Emergency Contact No <span className='text-red-600'>*</span></label>
    <PhoneInput
      name='emergency_contact_no'
      country={"pk"}
      value={values.emergency_contact_no}
      onChange={(value) => setFieldValue("emergency_contact_no", value)}
      inputStyle={{ width: "100%" }}
      onBlur={handleBlur}
    />
    {touched.emergency_contact_no && errors.emergency_contact_no ? <p className='text-red-500 pl-2 italic'>{errors.emergency_contact_no}</p> : null}
  </div>
</div>


<div className='w-full md:w-1/2 gap-5 mt-5'>
  <label>Relation <span className='text-red-600'>*</span></label>
  <input 
    type='text' 
    name='emergency_relation' 
    placeholder='Enter Relation' 
    value={values.emergency_relation || ''}
    className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '+ (errors.emergency_relation && touched.emergency_relation ? 'border-red-600': '')}
    onChange={handleChange}
    onBlur={handleBlur}
  />
  {touched.emergency_relation && errors.emergency_relation ? <p className='text-red-500 pl-2 italic'>{errors.emergency_relation}</p> : null}
</div>

<h1 className='font-bold text-lg text-gx-ink-soft py-2 border-t mt-5'>Member Address & Location Details:</h1>
<div className='flex flex-col md:flex-row justify-between gap-5 mt-3'>
  <div className='w-full'>
    <label>Address <span className='text-red-600'>*</span></label>
    <input 
      type='text' 
      name='address' 
      placeholder='Enter Address'
      value={values.address}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '+ (errors.address && touched.address ? 'border-red-600': '')}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    {touched.address && errors.address ? <p className='text-red-500 pl-2 italic'>{errors.address}</p> : null}
  </div>
  
  <div className='w-full'>
    <label className=''>Postal Code <span className='text-red-600'>*</span></label>
    <input 
      type='text' 
      name='postal_code' 
      placeholder='Enter Potal Code' 
      value={values.postal_code}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '+ (errors.postal_code && touched.postal_code ? 'border-red-600': '')}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    {touched.postal_code && errors.postal_code ? <p className='text-red-500 pl-2 italic'>{errors.postal_code}</p> : null}
  </div>
</div>

<div className='flex flex-col md:flex-row justify-between gap-5 mt-5'>
  <div className='w-full'>
    <label>Country <span className='text-red-600'>*</span></label>
    <select 
      name='country' 
      placeholder='Enter Country'
      value={values.country}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '+ (errors.country && touched.country ? 'border-red-600': '')}
      onChange={(e) => {
        handleChange(e); 
        getStates(e.target.value);
        getCities(e.target.value);
      }}
      onBlur={handleBlur}
    >
      <option value=''>Country</option>
      {countries?.map((country, index) => (
        <option key={index} value={country.isoCode}>{country.name}</option>
      ))}
    </select>
    {touched.country && errors.country ? <p className='text-red-500 pl-2 italic'>{errors.country}</p> : null}
  </div>
  
  <div className='w-full'>
    <label>State<span className='text-red-600'>*</span></label>
    <select 
      name='state' 
      placeholder='Enter State'
      value={values.state}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '+ (errors.state && touched.state ? 'border-red-600': '')}
      onChange={handleChange}
      onBlur={handleBlur}
    >
      <option value=''>State</option>
      {states?.map((state, index) => (
        <option key={index} value={state.isoCode}>{state.name}</option>
      ))}
    </select>
    {touched.state && errors.state ? <p className='text-red-500 pl-2 italic'>{errors.state}</p> : null}
  </div>
  
  <div className='w-full'>
    <label>City <span className='text-red-600'>*</span></label>
    <select 
      name='city' 
      placeholder='Enter City' 
      value={values.city}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '+ (errors.city && touched.city ? 'border-red-600': '')}
      onChange={handleChange}
      onBlur={handleBlur}
    >
      <option value=''>City</option>
      {cities?.map((city, index) => (
        <option key={index} value={city.name}>{city.name}</option>
      ))}
    </select>
    {touched.city && errors.city ? <p className='text-red-500 pl-2 italic'>{errors.city}</p> : null}
  </div>
</div>
<h1 className='font-bold text-lg text-gx-ink-soft py-2 border-t mt-5'>
  {isAddModalOpen ? 'Package Details:' : ''}
</h1>

{isAddModalOpen ? (
  <div className='w-full'>
    <label>Package <span className='text-red-600'>*</span></label>
    <select 
      name='package_id'
      value={values.package_id}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '+ (errors.package_id && touched.package_id ? 'border-red-600': '')}
      onChange={(e) => {
        handleChange(e)
        getMemberPackage(e.target.value)
        setFieldValue("update_package", true)
      }}
      onBlur={handleBlur}
      disabled={member.is_active ? currentDate > values.endRenewDate : false} 
    >
      <option value=''> Select Package </option>
      {packages?.map((pckg, index) => (
        <option key={index} value={pckg._id}>{pckg.title}</option>
      ))}
    </select>
    {(touched.package_id && errors.package_id) ? <p className='text-red-500 pl-2 italic'>{errors.package_id}</p> : null}
  </div>
) : null}
<h1 className="font-bold text-lg text-gx-ink-soft py-2 border-t mt-5">
  {isAddModalOpen && "Additional Details:"}
</h1>

{isAddModalOpen && (
  <div className="w-full space-y-4">

    {/* Registration Free Checkbox */}
    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="registration_free"
        checked={values.registration_free ?? true}
        onChange={(e) =>
          setFieldValue("registration_free", e.target.checked)
        }
        className="w-4 h-4"
      />
      <label className="font-medium">Registration Free</label>
    </div>

    {/* Dynamic Subscription Renewal Checkbox */}
    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="has_dynamic_subscription_renewal_day"
        checked={values.has_dynamic_subscription_renewal_day || false}
        onChange={(e) => {
          const checked = e.target.checked;
          setFieldValue("has_dynamic_subscription_renewal_day", checked);

          // Reset renewal day if unchecked
          if (!checked) {
            setFieldValue("subscription_renewal_day", null);
          }
        }}
        className="w-4 h-4"
      />
      <label className="font-medium">
        Enable Dynamic Subscription Renewal Day
      </label>
    </div>

    {/* Renewal Day Input (only if enabled) */}
    {values.has_dynamic_subscription_renewal_day && (
      <input
        type="number"
        name="subscription_renewal_day"
        min="1"
        max="31"
        value={values.subscription_renewal_day || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="Enter day (1-31)"
        className={
          "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
          (errors.subscription_renewal_day &&
          touched.subscription_renewal_day
            ? "border-red-600"
            : "")
        }
      />
    )}

  </div>
)}
{/* <div className='flex flex-col md:flex-row justify-between gap-5 mt-3'>
  <div className='w-full md:w-1/2'>
    <label>Discount <span className='text-red-600'>*</span></label>
    <input 
      type='number' 
      name='discount' 
      placeholder='Enter Discount' 
      value={values.discount}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0' +(errors.discount && touched.discount ? 'border-red-600':'')}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    {touched.discount && errors.discount ? <p className='text-red-500 pl-2 italic'>{errors.discount}</p>:null} 
  </div>
  
  <div className='w-full md:w-1/2'>
    <label>Discount Remarks</label>
    <input 
      type='text' 
      name='discount_remarks' 
      placeholder='Enter Remarks' 
      value={values.discount_remarks || ''}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '+ (errors.discount_remarks && touched.discount_remarks ? 'border-red-600': '')}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    {touched.discount_remarks && errors.discount_remarks ? <p className='text-red-500 pl-2 italic'>{errors.discount_remarks}</p> : null}
  </div>
</div> */}

{isAddModalOpen ? (
  <>
    <h1 className="font-bold text-lg text-gx-ink-soft py-2 border-t mt-5">
      Personal Trainer Details:
    </h1>
    <div className="mt-3">
      <label>Do you want a Personal Trainer?</label>
      <div className="ml-3">
        <div>
          <input
            type="radio"
            name="trainer"
            onChange={() => setFieldValue("is_trainer", true)}
            checked={values.is_trainer}
          />{" "}
          Yes
        </div>
        <div>
          <input
            type="radio"
            name="trainer"
            onChange={() => {
              setFieldValue("is_trainer", false);
              setFieldValue("trainer_id", "");
            }}
            checked={!values.is_trainer}
          />{" "}
          No
        </div>
      </div>
    </div>
  </>
) : null}


{values.is_trainer && (
  <div className='flex flex-col md:flex-row justify-between gap-5 mt-5'>
    <div className='w-full'>
      <label>Personal Trainer:</label>
      <select 
        name='trainer_id'
        value={values.trainer_id}
        className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '+ (errors.trainer_id && touched.trainer_id ? 'border-red-600': '')}
        onChange={(e) => {
          handleChange(e);
          setFieldValue("update_trainer", true)
        }}
        onBlur={handleBlur}
      >
        <option value=''>Select Personal Trainer</option>
        {trainers?.map((trainer, index) => (
          <option key={index} value={trainer._id}>{trainer.name}</option>
        ))}
      </select>
      {(touched.trainer_id && errors.trainer_id) ? <p className='text-red-500 pl-2 italic'>{errors.trainer_id}</p> : null}
    </div>
  </div>
)}

<h1 className='font-bold text-lg text-gx-ink-soft py-2 border-t mt-5'>Member Credentials:</h1>

<div className='flex flex-col md:flex-row justify-between gap-5 mt-3'>
  <div className='w-full'>
    <label>Email <span className='text-red-600'>*</span></label>
    <input 
      type='email' 
      name='email' 
      placeholder='Enter Email' 
      value={values.email}
      className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '+ (errors.email && touched.email ? 'border-red-600': '')}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    {touched.email && errors.email ? <p className='text-red-500 pl-2 italic'>{errors.email}</p> : null}
  </div>
  
  {!isLocationScoped ? (
    <div className='w-full'>
      <label>Location <span className='text-red-600'>*</span></label>
      <select 
        name='location_id'
        value={values.location_id}
        className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '+ (errors.location_id && touched.location_id ? 'border-red-600': '')}
        onChange={(e) => handleChange(e)}
        onBlur={handleBlur}
      >
        <option value=''>Select Location</option>
        {locations?.map((location, index) => (
          <option key={index} value={location._id}>{location.name}</option>
        ))}
      </select>
      {(touched.location_id && errors.location_id) ? <p className='text-red-500 pl-2 italic'>{errors.location_id}</p> : null}
    </div>
  ) : (
    <input type='hidden' name='location_id' value={values.location_id}/>
  )}
</div>

{isAddModalOpen ? (
  <div className='flex flex-col md:flex-row justify-between gap-5 mt-5'>
    <div className='w-full'>
      <label>Password <span className='text-red-600'>*</span></label>
      <div className='relative'>
        <input 
          type={showPassword ? 'text' : 'password'} 
          name='password' 
          placeholder='Enter Password'
          value={values.password}
          className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '+ (errors.password && touched.password ? 'border-red-600': '')}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <button 
          type='button' 
          className='absolute right-3 top-1/2 transform -translate-y-1/2 text-gx-ink-soft'
          onClick={()=>setShowPassword(!showPassword)}
        >
          {showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye}/>}
        </button>
      </div>
      {touched.password && errors.password ? <p className='text-red-500 pl-2 mt-1 italic'>{errors.password}</p> : null}
    </div>
  </div>
) : null}

<div className="flex justify-end items-center pt-3 mt-3 border-t">
  <button 
    type='submit' 
    className='bg-blue-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-blue-700'
    disabled={loading || buttonLoading}
  >
    <div className='flex items-center gap-2'>
      Submit
      {loading || buttonLoading ? 
        
          <div className=''><CircularProgress size={20}/></div>
         
      : null}
    </div>
  </button>
</div>
    </form>
  </CustomModal>
  
  <CustomModal isModal={isViewModalOpen} handleModal={toggleViewModal} size="4xl">
    <div className="px-6 pb-6">
      <div className="flex items-start justify-between gap-4 border-b border-gx-border pb-4 mb-5">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-gx-ink-soft">Quick view</p>
          <h1 className="text-2xl font-bold text-gx-ink tracking-tight">{member?.name || "Member"}</h1>
          <p className="text-sm text-gx-ink-soft mt-1">
            {[member?.location_id?.name, member?.phone].filter(Boolean).join(" · ") || "No contact on file"}
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
        {[
          ["Email", member?.email],
          ["Phone", member?.phone],
          ["Address", member?.address],
          ["Postal code", member?.postal_code],
          ["Club", member?.location_id?.name],
          ["Package", member?.package_id?.title],
        ].map(([label, value]) => (
          <div key={label} className="rounded-gx bg-gx-canvas border border-gx-border px-4 py-3">
            <p className="text-[11px] uppercase tracking-wide font-semibold text-gx-ink-soft">{label}</p>
            <p className="text-gx-ink font-medium mt-1 break-words">{value || "—"}</p>
          </div>
        ))}
      </div>
    </div>
  </CustomModal>

  <CustomModal isModal={isDeleteModalOpen} handleModal={toggleDeleteModal} size='md'>
    <div className='m-5'>
        <h2 className="text-xl font-medium">Delete Member?</h2>
        <p className="text-gx-ink-soft mt-3">Are you sure you want to delete this member?</p>
        <div className="my-5 w-full">
          <Button 
            variant="outlined"
            color="error"
            className='flex float-right' 
            onClick={deleteMember}
            disabled={buttonLoading}
            sx={{marginBottom: '16px', width: '100%', padding: '10px', borderRadius: '8px', fontSize: '16px', fontWeight: '500', '&:hover': { backgroundColor: '#f44336', color: '#fff' }}}
          >
            Delete
            {buttonLoading ? 
              
                <div className='ml-2 mt-1'><CircularProgress color='inherit' size={20}/></div>
              
            : null}
          </Button>
        </div>
    </div>
  </CustomModal>

  <CustomModal isModal={isEmailModalOpen} handleModal={toggleEmailModal} size='xl'>
    <h1 className='font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2'>Send Customized Email</h1>
    <div className='m-5'>
        <label className='text-gx-ink-soft'>Subject:</label>
        <input type='text' name='subject' placeholder='Subject' 
            value={emailData.subject}
            className={'border border-gx-border w-full p-2 rounded-md outline-0 '}
            onChange={(e) => setEmailData({
                ...emailData , 
                subject: e.target.value
            })}
        />
        <div className='mt-5'>
            <label className='text-gx-ink-soft'>Content:</label>
            <input
                id="email-editor"
                type="hidden"
            />
            <trix-editor input="email-editor" ref={editorRef}/>
            {/* <h3>Preview:</h3>
            <div
                dangerouslySetInnerHTML={{ __html: emailData.html }}
                style={{
                border: "1px solid #ddd",
                padding: "10px",
                borderRadius: "4px",
                background: "#f9f9f9",
                }}
            /> */}
            </div>
        <button className='bg-blue-800 p-2 px-5 rounded-lg text-white font-medium hover:bg-blue-700 mt-5 float-right mb-5' onClick={sendCustomizedEmail}>Send</button>
    </div>
  </CustomModal>

  <CustomModal isModal={isSmsModalOpen} handleModal={toggleSmsModal} size='xl'>
    <h1 className='font-bold text-2xl text-gx-ink p-5 border-b border-gx-border mx-2'>Send SMS</h1>
    <div className='m-5'>
      {!smsEnabled ? (
        <p className="mb-4 text-sm rounded-gx bg-gx-orange/10 text-gx-orange border border-gx-orange/20 px-3 py-2">
          SMS is not configured for this club yet. You can still compose a message; sending needs an active integration.
        </p>
      ) : null}
      <label className='text-gx-ink-soft'>Members</label>
      <p className='text-xs text-gx-ink-soft mb-2'>
        Pick people in the dropdown, or use group filters below (filters are resolved on the server — no member IDs sent).
      </p>
      <Autocomplete
        multiple
        disableCloseOnSelect
        disabled={smsHasBulkFilter}
        filterOptions={(x) => x}
        options={smsMemberOptions}
        loading={smsLoadingOptions}
        value={smsSelectedMembers}
        inputValue={smsInputValue}
        onInputChange={(_, newInputValue, reason) => {
          setSmsInputValue(newInputValue);
          if (reason === "input") {
            scheduleSmsMemberSearch(newInputValue);
          }
          if (reason === "clear") {
            scheduleSmsMemberSearch("");
          }
        }}
        onChange={(_, value) => {
          setSmsMemberFilters({ ...SMS_FILTER_DEFAULTS });
          setSmsSelectedMembers(value);
        }}
        onOpen={() => {
          if (!smsMemberOptions.length) {
            fetchSmsMemberOptions(smsInputValue, 1, false);
          }
        }}
        getOptionLabel={(option) =>
          `${option.name || ""} (${option.member_id ?? "—"}) · ${option.phone || "no phone"}`
        }
        isOptionEqualToValue={(option, value) => String(option._id) === String(value._id)}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <li key={option._id || key} {...optionProps}>
              <Box>
                <Typography variant="body2" className="font-semibold">
                  {option.name}
                </Typography>
                <Typography variant="caption" className="text-gx-ink-soft">
                  ID: {option.member_id ?? "—"} · {option.phone || "no phone"}
                  {option.is_active === false ? " · Inactive" : ""}
                </Typography>
              </Box>
            </li>
          );
        }}
        ListboxProps={{
          style: { maxHeight: 240 },
          onScroll: (event) => {
            const node = event.currentTarget;
            if (node.scrollTop + node.clientHeight >= node.scrollHeight - 8) {
              loadMoreSmsMemberOptions();
            }
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={
              smsHasBulkFilter
                ? "Group filter active — clear filters to pick individuals"
                : "Search name, phone, or member ID..."
            }
            size="small"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {smsLoadingOptions ? (
                    <CircularProgress color="inherit" size={18} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        sx={{
          bgcolor: "white",
          // Keep selected chips area at a fixed height with internal scroll
          "& .MuiAutocomplete-inputRoot": {
            maxHeight: 120,
            overflowY: "auto",
            flexWrap: "wrap",
            alignContent: "flex-start",
          },
          "& .MuiChip-root": {
            maxWidth: "100%",
          },
        }}
      />
      <div className='flex flex-wrap gap-2 mt-3'>
        {[
          { key: "all", label: "Select All" },
          { key: "active", label: "Select Active" },
          { key: "inactive", label: "Select Inactive" },
          { key: "new", label: "Select New" },
          { key: "restored", label: "Select Returning" },
          { key: "personal_coaching", label: "Select Personal Coaching" },
        ].map(({ key, label }) => {
          const active = Boolean(smsMemberFilters[key]);
          return (
            <button
              key={key}
              type="button"
              className={`p-2 px-3 rounded-lg text-white text-sm font-medium disabled:opacity-50 ${
                active
                  ? "bg-blue-800 hover:bg-blue-900 ring-2 ring-blue-300"
                  : "bg-gx-ink-soft hover:bg-gx-navy"
              }`}
              onClick={() => toggleSmsBulkFilter(key)}
            >
              {label}
            </button>
          );
        })}
        <button
          type="button"
          className='bg-gx-ink-soft p-2 px-3 rounded-lg text-white text-sm font-medium  disabled:opacity-50'
          onClick={clearAllSmsMembers}
          disabled={!smsHasBulkFilter && !smsSelectedMembers.length}
        >
          Clear All
        </button>
      </div>
      <p className='text-sm text-gx-ink-soft mt-2'>
        {smsHasBulkFilter
          ? `Group filter: ${[
              smsMemberFilters.all && "All",
              smsMemberFilters.active && "Active",
              smsMemberFilters.inactive && "Inactive",
              smsMemberFilters.new && "New",
              smsMemberFilters.restored && "Returning",
              smsMemberFilters.personal_coaching && "Personal Coaching",
            ]
              .filter(Boolean)
              .join(", ")}`
          : `${smsSelectedMembers.length} member(s) selected${
              smsMemberOptions.length ? ` · ${smsMemberOptions.length} loaded` : ""
            }${smsOptionsHasMore ? " · scroll for more" : ""}`}
      </p>

      <div className='mt-5'>
        <label className='text-gx-ink-soft'>Message</label>
        <textarea
          name='sms_message'
          rows={5}
          maxLength={CUSTOM_SMS_MAX_LENGTH}
          placeholder='Write your SMS message...'
          value={smsMessage}
          className='border border-gx-border w-full p-2 rounded-md outline-0 mt-1'
          onChange={(e) => setSmsMessage(e.target.value)}
        />
        <p className='text-xs text-gx-ink-soft mt-1 text-right'>
          {smsMessage.length} / {CUSTOM_SMS_MAX_LENGTH}
        </p>
      </div>

      <div className="flex justify-end gap-2 mt-5 mb-2">
        <button
          type="button"
          className="gx-cta-secondary"
          onClick={toggleSmsModal}
        >
          Cancel
        </button>
        <button
          type="button"
          className="gx-cta"
          onClick={sendCustomSms}
          disabled={smsSending}
        >
          {smsSending ? (
            <span className="flex items-center gap-2">
              Sending…
              <CircularProgress size={18} sx={{ color: "white" }} />
            </span>
          ) : (
            "Send SMS"
          )}
        </button>
      </div>
    </div>
  </CustomModal>

  <CustomModal isModal={isRestoreModalOpen} handleModal={toggleRestoreModal} size='md'>
    <div className='m-5'>
        <h2 className="text-xl font-medium">Restore Member?</h2>
        
        <div className="mt-3">
          <label className="block text-sm font-medium text-gx-ink">Subscription Start Date</label>
          <select
            className="mt-1 block w-full p-2 border border-gx-border rounded-gx shadow-gx-sm focus:ring focus:ring-blue-300"
            value={selectedSubStartDate} 
            onChange={(e) => setSelectedSubStartDate(e.target.value)}
          >
            <option value='' disabled>Please Select Subscription Date</option>
            {/* <option value={new Date().toISOString().split('T')[0]}>Today's Date</option>
            <option value={memberToRestore?.subscription?.end_date}>Last Subscription Date</option> */}
            <option value={'todayDate'}>Today's Date</option>
            <option value={'subscriptionDate'}>Last Subscription Date</option>
          </select>
        </div>

        <p className="text-gx-ink-soft mt-3">Choose an option to proceed:</p>
        
        <div className="mt-5 flex flex-col gap-3">
            <button 
                className='bg-blue-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-blue-700' 
                onClick={()=>showChangePackage(memberToRestore)}
            >
                Change Package
            </button>
            
            <button 
                className='bg-gx-orange p-2 px-5 rounded-lg text-white font-medium hover:bg-gx-orange' 
                onClick={()=>showChangeTrainer(memberToRestore)}
            >
                Change Trainer
            </button>
            
            {hasPermission(getSessionUser(), 'members:update') && (
            <button 
                className='bg-purple-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-purple-700' 
                onClick={()=>showUpdateModal(memberToRestore)}
            >
                Update Member Details
            </button>
            )}
        </div>

        <div className="flex justify-center my-5 w-full">
          <Button
              variant="contained"
              color="success" 
              className={`flex p-2 px-5  w-30 rounded-lg text-white font-medium  mt-5 float-center mb-5 ${selectedSubStartDate ? ' bg-green-600 hover:bg-green-700' : ' bg-gx-ink-soft'}`} 
              onClick={restoreMember} 
              disabled={!selectedSubStartDate || buttonLoading}
              sx={{marginBottom: '16px', py: '10px', px: '5rem', borderRadius: '8px', fontSize: '16px', fontWeight: '500', '&:hover': { backgroundColor: '#4caf50', color: '#fff' }}}
            >
              Restore
              {buttonLoading ? 
                
                  <div className='ml-2'><CircularProgress size={20}/></div>
                
              : null}
            </Button>
        </div>
    </div>
  </CustomModal>

  <CustomModal isModal={isAdvanceModalOpen} handleModal={toggleAdvanceModal} size='xl'>
  <div className='pt-5'></div>

  {/* Member Info Section */}
  <div className='m-5 p-4 flex flex-col md:flex-row justify-center gap-4 md:gap-10 text-gx-ink-soft border border-gx-border rounded-lg font-bold'>
    <div className='flex flex-col md:flex-row justify-start items-center gap-2'>
      <h1>Name:</h1>
      <p className='font-semibold'>{memberToAdvance?.name}</p>
    </div>
    <div className='flex flex-col md:flex-row justify-start items-center gap-2'>
      <h1>Member ID:</h1>
      <p className='font-semibold'>{memberToAdvance?.member_id}</p>
    </div>
  </div>

  {/* Payment Method */}
  <div className='mx-5 md:mx-7 text-gx-ink-soft flex flex-col md:flex-row justify-between items-start md:items-center gap-2 md:gap-0'>
    <label className='font-bold w-full md:w-1/2'>Payment Method:</label>
    <select
      className='font-semibold border border-gx-border w-full p-2 rounded-lg outline-0'
      value={paymentData.payment_method}
      onChange={(e) => setPaymentData({ ...paymentData, payment_method: e.target.value })}
    >
      <option value='Cash'>Cash</option>
      <option value='Card'>Card</option>
      <option value='Online'>Online</option>
      <option value='Jazzcash'>JazzCash</option>
      <option value='Cheque'>Cheque</option>
      <option value='Wallet'>Wallet</option>
      {/* <option value='Other'>Other</option> */}
    </select>
  </div>

  {/* Amount */}
  <div className='mx-5 md:mx-7 my-5 text-gx-ink-soft flex flex-col md:flex-row justify-between items-start md:items-center gap-2 md:gap-0'>
    <label className='font-bold w-full md:w-1/2'>Amount:</label>
    <input
      type='number'
      className='font-semibold border border-gx-border w-full p-2 rounded-lg outline-0'
      value={paymentData.amount}
      onChange={(e) => setPaymentData({ ...paymentData, amount: e.target.value })}
    />
  </div>
  {(paymentData.payment_method !=='Cash') && (
  <div className='mx-5 md:mx-7 my-5 text-gx-ink-soft flex flex-col md:flex-row justify-between items-start md:items-center gap-2 md:gap-0'>
    <label className='font-bold w-full md:w-1/2'>Reference No:</label>
    <input
      type='number'
      className='font-semibold border border-gx-border w-full p-2 rounded-lg outline-0'
      value={paymentData.reference_number}
      onChange={(e) => setPaymentData({ ...paymentData, reference_number: e.target.value })}
      
    />
  </div>
    )}

  {/* Submit Button */}
  <div className='m-5 text-center'>
    <div className='flex justify-center gap-3 my-5'>
      <Button
        variant="contained"
        color="primary"
        onClick={handleAdvancePayment}
        disabled={buttonLoading}
        sx={{marginBottom: '16px',  py: '10px',px:'5rem', borderRadius: '8px', fontSize: '16px', fontWeight: '500', '&:hover': { backgroundColor: '#1e88e5', color: '#fff' }}}
      >
        Create Payment
        {buttonLoading ? 
          
            <div className='ml-2'><CircularProgress size={20} color='#fff'/></div>
          
        : null}
      </Button>
    </div>
  </div>
</CustomModal>



<CustomModal isModal={isChargesModalOpen} handleModal={toggleChargesModal} size='xl'>
  <div className='pt-5'></div>

  {/* Member Info Section */}
  <div className='m-5 p-4 flex flex-col md:flex-row justify-center gap-4 md:gap-10 text-gx-ink-soft border border-gx-border rounded-lg font-bold'>
    <div className='flex flex-col md:flex-row justify-start items-center gap-2'>
      <h1>Name:</h1>
      <p className='font-semibold'>{memberToAdvance?.name}</p>
    </div>
    <div className='flex flex-col md:flex-row justify-start items-center gap-2'>
      <h1>Member ID:</h1>
      <p className='font-semibold'>{memberToAdvance?.member_id}</p>
    </div>
  </div>

  {/* Charges Name */}
  <div className='mx-5 md:mx-7 text-gx-ink-soft flex flex-col md:flex-row justify-between items-start md:items-center gap-2 md:gap-0'>
    <label className='font-bold w-full md:w-1/2'>Charges Name:</label>
    <input
      type='text'
      className='font-semibold border border-gx-border w-full p-2 rounded-lg outline-0'
      value={damagesData.charges_name}
      onChange={(e) => setDamagesData({ ...damagesData, charges_name: e.target.value })}
    />
  </div>

  {/* Amount */}
  <div className='mx-5 md:mx-7 my-5 text-gx-ink-soft flex flex-col md:flex-row justify-between items-start md:items-center gap-2 md:gap-0'>
    <label className='font-bold w-full md:w-1/2'>Amount:</label>
    <input
      type='number'
      className='font-semibold border border-gx-border w-full p-2 rounded-lg outline-0'
      value={damagesData.amount}
      onChange={(e) => setDamagesData({ ...damagesData, amount: e.target.value })}
    />
  </div>

  {/* Remarks */}
  <div className='mx-5 md:mx-7 text-gx-ink-soft flex flex-col md:flex-row justify-between items-start md:items-center gap-2 md:gap-0'>
    <label className='font-bold w-full md:w-1/2'>Remarks:</label>
    <input
      type='text'
      className='font-semibold border border-gx-border w-full p-2 rounded-lg outline-0'
      value={damagesData.remarks}
      onChange={(e) => setDamagesData({ ...damagesData, remarks: e.target.value })}
    />
  </div>

  {/* Button */}
  <div className='m-5 text-center'>
    <div className='flex justify-center items-center gap-3 my-5'>
      <Button
        variant="contained"
        color="primary"
        sx={{marginBottom: '16px',  py: '10px',px:'5rem', borderRadius: '8px', fontSize: '16px', fontWeight: '500', '&:hover': { backgroundColor: '#1e88e5', color: '#fff' }}}
        onClick={handleDamageInvoice}
        disabled={buttonLoading}
      >
        Create Invoice
        {buttonLoading ? 
          
            <div className='ml-2'><CircularProgress size={20} color='#fff'/></div>
          
        : null}
      </Button>
    </div>
  </div>
</CustomModal>



    {/* <CustomModal isModal={isPackageModalOpen} handleModal={togglePackageModal} size='xl'> */}
        {/* <div className='pt-5'></div>
        <div className='m-5 p-2 flex-col justify-center gap-10 text-gx-ink-soft border border-gx-border rounded-lg font-bold'>
        <div className='flex justify-between gap-5 mt-3'>
            <div className='w-full'>
                <label>Package <span className='text-red-600'>*</span></label>
                <select name='package_id'
                 value={selectedPackage}
                 className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '}
                 onChange={(e) => {
                    setSelectedPackage(e.target.value)
                    getMemberPackage(e.target.value)
                }}
                onBlur={handleBlur}
                disabled={currentDate > values.endRenewDate || false} 
                 >
                    <option value=''>Select Package</option>
                    {
                        packages?.map((pckg , index)=>(
                            <option key={index} value={pckg._id}>{pckg.title}</option>
                        ))
                    }
                </select>
               
            </div>
            </div>
            
            </div>
            <button className="bg-blue-500 text-white font-semibold py-2 px-4 rounded-lg hover:bg-blue-600 transition duration-300 m-5" onClick={handleChangePackage}>
      Submit
    </button> */}
    <Modal open={isPackageModalOpen} onClose={togglePackageModal}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: {
        xs: "90%",    // 90% width on extra small screens (mobile)
        sm: "80%",    // 80% width on small screens
        md: "60%",    // 60% width on medium screens
        lg: 400,      // fixed 400px on large screens
      },
      maxWidth: 400,   // maximum width it can grow to
      bgcolor: "background.paper",
      boxShadow: 24,
      borderRadius: 2,
      p: 3,
    }}
  >
    <FormControl fullWidth sx={{ mb: 3 }}>
      <InputLabel>Package</InputLabel>
      <Select
        value={selectedPackage || ''}
        onChange={(e) => setSelectedPackage(e.target.value)}
        label="Package"
      >
        {packages?.map((pckg) => (
          <MenuItem key={pckg._id} value={pckg._id}>
            {pckg.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    <Button
      variant="contained"
      color="primary"
      fullWidth
      onClick={handleChangePackage}
      disabled={!selectedPackage || buttonLoading} // Disable if no package selected or submitting
      className='flex'
      sx={{ 
        mt: 2,
        py: 1.5,      // Add some vertical padding for better touch targets on mobile
      }}
    >
      Submit
      {buttonLoading && (
        
          <div className='ml-2 mt-1'><CircularProgress size={20} color='#fff'/></div>
        
      )}
    </Button>
  </Box>
</Modal>

<Modal open={isTrainerModalOpen} onClose={toggleTrainerModal}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: { xs: '90%', sm: 400 }, // 90% width on small screens, 400px on larger screens
      bgcolor: "background.paper",
      boxShadow: 24,
      borderRadius: 2,
      p: 4,
      display: "flex",
      flexDirection: "column",
      gap: 2,
    }}
  >
    <Typography variant="h6" align="center" sx={{ fontWeight: "bold", mb: 2 }}>
      Want a Personal Trainer?
    </Typography>

    <FormControlLabel
      control={
        <Checkbox
          checked={isTrainer}
          onChange={() => {
            setIsTrainer(!isTrainer);
            if (isTrainer) setSelectedTrainer(null);
          }}
          color="primary"
        />
      }
      label="Yes, I want a personal trainer"
    />

    {isTrainer && (
      <FormControl fullWidth>
        <InputLabel>Choose Trainer</InputLabel>
        <Select
          value={selectedTrainer}
          onChange={(e) => setSelectedTrainer(e.target.value)}
        >
          {trainers?.map((trainer) => (
            <MenuItem key={trainer._id} value={trainer._id}>
              {trainer.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )}

    {/* Submit Button */}
    <Button
      variant="contained"
      color="primary"
      fullWidth
      onClick={handleChangeTrainer}
      disabled={selectedTrainer === member.trainer_id || buttonLoading} // Button disabled if no trainer selected or submitting
      className='flex'
      sx={{
        mt: 2,
        py: 1.5, // Taller button
        fontSize: "16px",
        fontWeight: "bold",
      }}
    >
      Submit
      {buttonLoading && (
        
          <div className='ml-2 mt-1'><CircularProgress size={20} color='#fff'/></div>
        
      )}
    </Button>
  </Box>
</Modal>

<StatsModal 
  activeMembers={counts.active ?? active_members}
  inactiveMembers={counts.inactive ?? inactive_members}
  newMembers={counts.new ?? new_members}
  restoredMembers={counts.restored ?? restored_members}
  totalMembers={counts.all ?? 0}
  membersWithTrainers={counts.with_trainer_active ?? 0}
  personalCoachingMembers={counts.personal_coaching ?? 0}
  open={open}
  setOpen={setOpen}
/>

<ResetMemberPasswordModal
  isOpen={isResetPasswordModalOpen}
  onClose={() => {
    setIsResetPasswordModalOpen(false);
    setMemberForPasswordReset(null);
  }}
  member={memberForPasswordReset}
  actingUserId={actingUserId}
  onSuccess={(message) => {
    setIsSuccessAlert(true);
    setIsFailureAlert(false);
    setSuccessMessage(message || 'Member password updated.');
    setIsPopupOpen(true);
    setTimeout(() => setIsPopupOpen(false), 5000);
  }}
  onError={(message) => {
    setIsFailureAlert(true);
    setIsSuccessAlert(false);
    setFailureMessage(message || 'Failed to reset password.');
    setIsPopupOpen(true);
    setTimeout(() => setIsPopupOpen(false), 5000);
  }}
/>

{
    isPopupOpen && (
      <Popup 
      onClose={() => setIsPopupOpen(false)}
      alertType={isSuccessAlert ? 'success' : isFaliureAlert ? 'failure' : ''}
      message={isSuccessAlert ? successMessage : isFaliureAlert ? failureMessage : ''}
      />
    )
  }

      
    </>
  )
}




export default Members
